import React from 'react';

import { CustomIcons } from '@types';

export const customIconsObj: Record<
  CustomIcons,
  {
    path: any;
    viewBox?: string;
  }
> = {
  bolt: {
    path: (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.48362 13.9172C4.28246 13.7842 4.2048 13.5267 4.29897 13.3047L6.33733 8.50005H4.5C4.32877 8.50005 4.16945 8.41242 4.07775 8.26782C3.98605 8.12322 3.97472 7.94174 4.04773 7.78686L6.64032 2.28681C6.72285 2.11172 6.89902 2 7.09259 2H10.5485C10.72 2 10.8795 2.0879 10.9712 2.23287C11.0628 2.37784 11.0737 2.55965 11.0001 2.71456L9.43924 6.00006H11.5C11.7005 6.00006 11.8816 6.11985 11.9601 6.30437C12.0386 6.48889 11.9992 6.70245 11.8601 6.84688L5.11942 13.8468C4.95217 14.0205 4.68479 14.0501 4.48362 13.9172ZM10.3244 7.00006H8.64814C8.47664 7.00006 8.31711 6.91217 8.22548 6.7672C8.13386 6.62222 8.12292 6.44041 8.19652 6.2855L9.75742 3H7.40966L5.28845 7.50005H7.09259C7.26034 7.50005 7.4169 7.58417 7.5095 7.72404C7.6021 7.86391 7.61839 8.0409 7.55288 8.19532L6.27675 11.2033L10.3244 7.00006Z"
          fill="currentColor"
        />
      </svg>
    ),
    viewBox: '0 0 16 16',
  },
  close: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 4L5 12"
          strokeWidth="2"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 4L13 12"
          strokeWidth="2"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 20 20',
  },
  'color-picker': {
    path: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.9993 5.99998L17.9993 13"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.99983 20V15.4239L15.0968 4.32701C15.3106 4.1174 15.5981 3.99998 15.8976 3.99998C16.197 3.99998 16.4845 4.1174 16.6984 4.32701L19.6728 7.30144C19.8824 7.51529 19.9998 7.8028 19.9998 8.10225C19.9998 8.4017 19.8824 8.68921 19.6728 8.90306L8.57588 20H3.99983Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 26 26',
  },
  'component-accordion': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M26 18L29.471 21.486L32.942 18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.742 14.7891H19.003C15.928 14.7891 14 16.9661 14 20.0481V28.3621C14 31.4441 15.919 33.6211 19.003 33.6211H27.827C30.912 33.6211 32.831 31.4441 32.831 28.3621V24.3341"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="26" y="23" width="2" height="12" rx="1" transform="rotate(90 26 23)" fill="#5C5A62" />
        <rect x="26" y="28" width="2" height="12" rx="1" transform="rotate(90 26 28)" fill="#5C5A62" />
      </svg>
    ),
  },
  'component-bar-chart': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect
          x="-1"
          y="1"
          width="7"
          height="16"
          rx="2"
          transform="matrix(-1 0 0 1 32 13)"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect
          x="-1"
          y="1"
          width="7"
          height="8"
          rx="2"
          transform="matrix(-1 0 0 1 21 21)"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  'component-badge': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14L19.67 14C16.28 14 14 16.38 14 19.92L14 28.09C14 31.62 16.28 34 19.67 34L28.34 34C31.73 34 34 31.62 34 28.09L34 19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="19" y="25" width="2" height="5" rx="1" transform="rotate(-90 19 25)" fill="currentColor" />
        <rect
          x="24"
          y="19"
          width="10"
          height="5"
          rx="2"
          transform="rotate(90 24 19)"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M31.5 15L28.2819 23.2751C28.1006 23.7414 28.1006 24.2586 28.2819 24.7249L31.5 33"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  'component-button': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect
          x="30"
          y="22"
          width="5"
          height="12"
          rx="2"
          transform="rotate(90 30 22)"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  'component-board': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="19" y="14" width="2" height="20" rx="1" fill="currentColor" />
        <rect x="34" y="19" width="2" height="20" rx="1" transform="rotate(90 34 19)" fill="currentColor" />
        <rect x="27" y="14" width="2" height="20" rx="1" fill="currentColor" />
        <rect x="34" y="27" width="2" height="20" rx="1" transform="rotate(90 34 27)" fill="currentColor" />
      </svg>
    ),
  },
  'component-breadcrumb': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <mask
          id="path-2-outside-1_5091_788"
          maskUnits="userSpaceOnUse"
          x="22.9722"
          y="19"
          width="13"
          height="10"
          fill="black"
        >
          <rect fill="white" x="22.9722" y="19" width="13" height="10" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.3386 23.1214C25.5558 22.3385 26.1102 21 27.2173 21H30.3889C30.9193 21 31.428 21.2107 31.8031 21.5858L32.8031 22.5858C33.5841 23.3669 33.5841 24.6332 32.8031 25.4143L31.8031 26.4142C31.428 26.7893 30.9193 27 30.3889 27H27.2173C26.1102 27 25.5558 25.6615 26.3386 24.8787V24.8787C26.8239 24.3934 26.8239 23.6066 26.3386 23.1214V23.1214Z"
          />
        </mask>
        <path
          d="M31.8031 21.5858L30.3889 23L31.8031 21.5858ZM30.3889 19H27.2173V23H30.3889V19ZM34.2173 21.1716L33.2173 20.1716L30.3889 23L31.3889 24L34.2173 21.1716ZM33.2173 27.8285L34.2173 26.8285L31.3889 24L30.3889 25L33.2173 27.8285ZM27.2173 29H30.3889V25H27.2173V29ZM27.7528 26.2929C29.0192 25.0266 29.0191 22.9735 27.7529 21.7072L24.9244 24.5356C24.6286 24.2398 24.6286 23.7603 24.9244 23.4645L27.7528 26.2929ZM27.2173 25C27.892 25 28.23 25.8158 27.7528 26.2929L24.9244 23.4645C22.8817 25.5072 24.3284 29 27.2173 29V25ZM30.3889 25L30.3889 25V29C31.4497 29 32.4671 28.5786 33.2173 27.8285L30.3889 25ZM31.3889 24L31.3889 24L34.2173 26.8285C35.7794 25.2664 35.7794 22.7337 34.2173 21.1716L31.3889 24ZM27.2173 19C24.3283 19 22.8817 22.4929 24.9244 24.5356L27.7529 21.7072C28.2299 22.1842 27.8921 23 27.2173 23V19ZM30.3889 23L30.3889 23L33.2173 20.1716C32.4672 19.4214 31.4497 19 30.3889 19V23Z"
          fill="currentColor"
          mask="url(#path-2-outside-1_5091_788)"
        />
        <mask
          id="path-4-outside-2_5091_788"
          maskUnits="userSpaceOnUse"
          x="12.9722"
          y="19"
          width="13"
          height="10"
          fill="black"
        >
          <rect fill="white" x="12.9722" y="19" width="13" height="10" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3386 23.1214C15.5558 22.3385 16.1102 21 17.2173 21H20.3889C20.9193 21 21.428 21.2107 21.8031 21.5858L22.8031 22.5858C23.5841 23.3669 23.5841 24.6332 22.8031 25.4143L21.8031 26.4142C21.428 26.7893 20.9193 27 20.3889 27H17.2173C16.1102 27 15.5558 25.6615 16.3386 24.8787V24.8787C16.8239 24.3934 16.8239 23.6066 16.3386 23.1214V23.1214Z"
          />
        </mask>
        <path
          d="M21.8031 21.5858L20.3889 23L21.8031 21.5858ZM20.3889 19H17.2173V23H20.3889V19ZM24.2173 21.1716L23.2173 20.1716L20.3889 23L21.3889 24L24.2173 21.1716ZM23.2173 27.8285L24.2173 26.8285L21.3889 24L20.3889 25L23.2173 27.8285ZM17.2173 29H20.3889V25H17.2173V29ZM17.7528 26.2929C19.0192 25.0266 19.0191 22.9735 17.7529 21.7072L14.9244 24.5356C14.6286 24.2398 14.6286 23.7603 14.9244 23.4645L17.7528 26.2929ZM17.2173 25C17.892 25 18.23 25.8158 17.7528 26.2929L14.9244 23.4645C12.8817 25.5072 14.3284 29 17.2173 29V25ZM20.3889 25L20.3889 25V29C21.4497 29 22.4671 28.5786 23.2173 27.8285L20.3889 25ZM21.3889 24L21.3889 24L24.2173 26.8285C25.7794 25.2664 25.7794 22.7337 24.2173 21.1716L21.3889 24ZM17.2173 19C14.3283 19 12.8817 22.4929 14.9244 24.5356L17.7529 21.7072C18.2299 22.1842 17.8921 23 17.2173 23V19ZM20.3889 23L20.3889 23L23.2173 20.1716C22.4672 19.4214 21.4497 19 20.3889 19V23Z"
          fill="currentColor"
          mask="url(#path-4-outside-2_5091_788)"
        />
        <path d="M15 32H24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M25 16L34 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
  },
  'component-card': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path d="M14 26H34" stroke="currentColor" strokeWidth="2" />
        <rect x="26" y="29" width="2" height="12" rx="1" transform="rotate(90 26 29)" fill="currentColor" />
      </svg>
    ),
  },
  'component-calendar': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="14" y="21" width="2" height="20" rx="1" transform="rotate(-90 14 21)" fill="currentColor" />
        <circle cx="19" cy="25" r="1" fill="currentColor" />
        <circle cx="19" cy="29" r="1" fill="currentColor" />
        <circle cx="24" cy="25" r="1" fill="currentColor" />
        <circle cx="24" cy="29" r="1" fill="currentColor" />
        <circle cx="29" cy="25" r="1" fill="currentColor" />
        <circle cx="29" cy="29" r="1" fill="currentColor" />
      </svg>
    ),
  },
  'component-circular-progress': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <mask
          id="path-2-outside-1_5091_804"
          maskUnits="userSpaceOnUse"
          x="12"
          y="12"
          width="24"
          height="24"
          fill="black"
        >
          <rect fill="white" x="12" y="12" width="24" height="24" />
          <path d="M32.9597 24C33.5342 24 34.0056 24.467 33.9459 25.0385C33.7778 26.6492 33.2202 28.2005 32.3147 29.5557C31.2159 31.2002 29.6541 32.4819 27.8268 33.2388C25.9996 33.9957 23.9889 34.1937 22.0491 33.8079C20.1093 33.422 18.3275 32.4696 16.9289 31.0711C15.5304 29.6725 14.578 27.8907 14.1921 25.9509C13.8063 24.0111 14.0043 22.0004 14.7612 20.1732C15.5181 18.3459 16.7998 16.7841 18.4443 15.6853C19.7995 14.7798 21.3508 14.2222 22.9615 14.0541C23.533 13.9944 24 14.4658 24 15.0403V15.0403C24 15.6149 23.5323 16.0736 22.9626 16.1489C21.7642 16.3072 20.613 16.7386 19.6002 17.4153C18.2979 18.2855 17.2829 19.5223 16.6835 20.9694C16.0841 22.4165 15.9272 24.0088 16.2328 25.545C16.5384 27.0812 17.2926 28.4923 18.4002 29.5998C19.5077 30.7074 20.9188 31.4616 22.455 31.7672C23.9912 32.0728 25.5835 31.9159 27.0306 31.3165C28.4777 30.7171 29.7145 29.7021 30.5847 28.3998C31.2614 27.387 31.6928 26.2358 31.8511 25.0374C31.9264 24.4677 32.3851 24 32.9597 24V24Z" />
        </mask>
        <path
          d="M32.9597 24C33.5342 24 34.0056 24.467 33.9459 25.0385C33.7778 26.6492 33.2202 28.2005 32.3147 29.5557C31.2159 31.2002 29.6541 32.4819 27.8268 33.2388C25.9996 33.9957 23.9889 34.1937 22.0491 33.8079C20.1093 33.422 18.3275 32.4696 16.9289 31.0711C15.5304 29.6725 14.578 27.8907 14.1921 25.9509C13.8063 24.0111 14.0043 22.0004 14.7612 20.1732C15.5181 18.3459 16.7998 16.7841 18.4443 15.6853C19.7995 14.7798 21.3508 14.2222 22.9615 14.0541C23.533 13.9944 24 14.4658 24 15.0403V15.0403C24 15.6149 23.5323 16.0736 22.9626 16.1489C21.7642 16.3072 20.613 16.7386 19.6002 17.4153C18.2979 18.2855 17.2829 19.5223 16.6835 20.9694C16.0841 22.4165 15.9272 24.0088 16.2328 25.545C16.5384 27.0812 17.2926 28.4923 18.4002 29.5998C19.5077 30.7074 20.9188 31.4616 22.455 31.7672C23.9912 32.0728 25.5835 31.9159 27.0306 31.3165C28.4777 30.7171 29.7145 29.7021 30.5847 28.3998C31.2614 27.387 31.6928 26.2358 31.8511 25.0374C31.9264 24.4677 32.3851 24 32.9597 24V24Z"
          stroke="currentColor"
          strokeWidth="4"
          mask="url(#path-2-outside-1_5091_804)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5145 15C32.5145 14.4477 32.0668 14 31.5145 14C30.9623 14 30.5145 14.4477 30.5145 15V16.3676H29.147C28.5947 16.3676 28.147 16.8154 28.147 17.3676C28.147 17.9199 28.5947 18.3676 29.147 18.3676H30.5145V19.7352C30.5145 20.2875 30.9623 20.7352 31.5145 20.7352C32.0668 20.7352 32.5145 20.2875 32.5145 19.7352V18.3676H33.8822C34.4345 18.3676 34.8822 17.9199 34.8822 17.3676C34.8822 16.8154 34.4345 16.3676 33.8822 16.3676H32.5145V15Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-checkbox': {
    viewBox: '0 0 48 48',
    path: (
      <svg
        version="1.1"
        id="Camada_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
        xmlSpace="preserve"
      >
        <style type="text/css">
          {`
            .st0{
              fill: none;
              stroke: currentColor;
              stroke-width: 2;
            }
            .st1{
              fill: none;
            }
            .st2{
              fill: currentColor;
            }
          `}
        </style>
        <path
          className="st0"
          d="M31.8,6H16.2C10.1,6,6,10.3,6,16.7v14.7C6,37.7,10.1,42,16.2,42h15.6C37.9,42,42,37.7,42,31.4V16.7
	C42,10.3,37.9,6,31.8,6z"
        />
        <g>
          <path
            className="st1"
            d="M23.1,14.5h-5.8c-1.7,0-2.8,1.1-2.8,2.9v5.4c0,1.8,1.1,2.9,2.8,2.9h0.2v-1.5c0-1.7,0.6-3.3,1.7-4.4
		s2.6-1.8,4.3-1.8h2.4v-0.7C25.8,15.6,24.8,14.5,23.1,14.5z"
          />
          <path
            className="st2"
            d="M17.3,25.8c-1.7,0-2.8-1.1-2.8-2.9v-5.4c0-1.8,1.1-2.9,2.8-2.9h5.8c1.7,0,2.8,1.1,2.8,2.9v0.7h2v-0.7
		c0-2.9-2-4.9-4.8-4.9h-5.8c-2.8,0-4.8,2-4.8,4.9v5.4c0,2.9,2,4.9,4.8,4.9h0.2v-2H17.3z"
          />
          <path
            className="st2"
            d="M33.9,19.9c-1.1-1.1-2.6-1.8-4.3-1.8h-1.7h-2h-2.4c-1.7,0-3.2,0.6-4.3,1.8c-1.1,1.1-1.7,2.7-1.7,4.4v1.5v2V30
		c0,1.7,0.6,3.3,1.7,4.4c1.1,1.1,2.6,1.8,4.3,1.8h6.1c1.7,0,3.2-0.6,4.3-1.8c1.1-1.1,1.6-2.7,1.6-4.4v-5.7
		C35.5,22.6,34.9,21,33.9,19.9z M33.5,30c0,1.2-0.4,2.2-1.1,3c-0.7,0.7-1.7,1.1-2.9,1.1h-6.1c-1.2,0-2.2-0.4-2.9-1.1
		c-0.7-0.7-1.1-1.8-1.1-3v-2.2v-2v-1.5c0-1.2,0.4-2.3,1.1-3s1.7-1.1,2.9-1.1h2.4h2h1.7c1.2,0,2.2,0.4,2.9,1.1c0.7,0.7,1.1,1.8,1.1,3
		V30z"
          />
        </g>
        <path
          className="st2"
          d="M25.2,30.5c-0.3,0-0.5-0.1-0.7-0.3l-2.7-2.6c-0.4-0.4-0.4-1,0-1.3c0.4-0.4,1-0.4,1.4,0l2,1.9l4.7-4.4
	c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.3l-5.4,5.1C25.7,30.4,25.4,30.5,25.2,30.5z"
        />
      </svg>
    ),
  },
  'component-container': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8416 14.9408C16.0437 13.6858 17.7322 13 19.67 13H28.34C30.278 13 31.9645 13.6859 33.1643 14.9417C34.3602 16.1934 35 17.9344 35 19.92V24.7642C35.1634 24.8859 35.3172 25.0217 35.46 25.1712C36.1881 25.9332 36.56 26.9756 36.56 28.1258V32.4395C36.56 33.5877 36.1876 34.6289 35.4596 35.3899C34.7278 36.155 33.7094 36.56 32.5715 36.56H27.9938C26.8561 36.56 25.8368 36.1551 25.1039 35.3909C24.9858 35.2677 24.877 35.1372 24.7776 35H19.67C17.7323 35 16.044 34.3143 14.842 33.0609C13.6435 31.8112 13 30.0725 13 28.09V19.92C13 17.9332 13.6431 16.1921 14.8416 14.9408ZM24.0306 33C24.0102 32.8166 24 32.6296 24 32.4395V28.1258C24 26.9744 24.374 25.9318 25.1035 25.1702C25.8365 24.4049 26.856 24 27.9938 24H32.5715C32.7164 24 32.8593 24.0066 33 24.0196V19.92C33 18.3656 32.5048 17.1466 31.7182 16.3233C30.9355 15.5041 29.792 15 28.34 15H19.67C18.2178 15 17.0713 15.5042 16.2859 16.3242C15.4969 17.1479 15 18.3668 15 19.92V28.09C15 29.6375 15.4965 30.8538 16.2855 31.6766C17.071 32.4957 18.2177 33 19.67 33H24.0306ZM26 28.1258C26 27.408 26.2279 26.8877 26.5478 26.5537C26.8642 26.2234 27.3416 26 27.9938 26H32.5715C33.2235 26 33.6991 26.2232 34.0139 26.5528C34.3327 26.8863 34.56 27.4068 34.56 28.1258V32.4395C34.56 33.1552 34.3331 33.6742 34.0144 34.0075C33.6994 34.3367 33.2236 34.56 32.5715 34.56H27.9938C27.3415 34.56 26.8639 34.3365 26.5474 34.0065C26.2275 33.6729 26 33.154 26 32.4395V28.1258Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-data-container': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M32.5715 25H27.9938C26.2038 25 25 26.2566 25 28.1258V32.4395C25 34.3034 26.2038 35.56 27.9938 35.56H32.5715C34.3614 35.56 35.56 34.3034 35.56 32.4395V28.1258C35.56 26.2566 34.3614 25 32.5715 25Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle cx="20" cy="29" r="2" fill="currentColor" />
        <circle cx="29" cy="20" r="2" fill="currentColor" />
        <path d="M20 29V22C20 20.8954 20.8954 20 22 20H29" stroke="currentColor" strokeWidth="2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.67 13C17.7322 13 16.0437 13.6858 14.8416 14.9408C13.6431 16.1921 13 17.9332 13 19.92V28.09C13 30.0725 13.6435 31.8112 14.842 33.0609C16.044 34.3143 17.7323 35 19.67 35H25V33H19.67C18.2177 33 17.071 32.4957 16.2855 31.6766C15.4965 30.8538 15 29.6375 15 28.09V19.92C15 18.3668 15.4969 17.1479 16.2859 16.3242C17.0713 15.5042 18.2178 15 19.67 15H28.34C29.792 15 30.9355 15.5041 31.7182 16.3233C32.5048 17.1466 33 18.3656 33 19.92V25H35V19.92C35 17.9344 34.3602 16.1934 33.1643 14.9417C31.9645 13.6859 30.278 13 28.34 13H19.67Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-dynamic-form': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="25" y="13" width="2" height="12" rx="1" transform="rotate(90 25 13)" fill="currentColor" />
        <rect x="35" y="18" width="2" height="22" rx="1" transform="rotate(90 35 18)" fill="currentColor" />
        <rect
          x="34"
          y="24"
          width="10"
          height="20"
          rx="3"
          transform="rotate(90 34 24)"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path d="M27 34L34 28" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  'component-grid': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="17" y="18" width="2" height="12" rx="1" fill="currentColor" />
        <rect x="21" y="18" width="2" height="12" rx="1" fill="currentColor" />
        <rect x="25" y="18" width="2" height="12" rx="1" fill="currentColor" />
        <rect x="29" y="18" width="2" height="12" rx="1" fill="currentColor" />
      </svg>
    ),
  },
  'component-grid-item': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="17" y="22" width="2" height="8" rx="1" fill="currentColor" />
        <rect x="21" y="21" width="2" height="9" rx="1" fill="currentColor" />
        <rect x="25" y="18" width="2" height="12" rx="1" fill="currentColor" />
        <rect x="29" y="18" width="2" height="12" rx="1" fill="currentColor" />
        <path
          d="M19.5715 12H14.9938C13.2038 12 12 13.2566 12 15.1258V19.4395C12 21.3034 13.2038 22.56 14.9938 22.56H19.5715C21.3614 22.56 22.56 21.3034 22.56 19.4395V15.1258C22.56 13.2566 21.3614 12 19.5715 12Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 13V15H28.34C29.792 15 30.9355 15.5041 31.7182 16.3233C32.5048 17.1466 33 18.3656 33 19.92V28.09C33 29.6387 32.5052 30.8552 31.7186 31.6775C30.9358 32.4959 29.7921 33 28.34 33H19.67C18.2177 33 17.071 32.4957 16.2855 31.6766C15.4965 30.8538 15 29.6375 15 28.09V22H13V28.09C13 30.0725 13.6435 31.8112 14.842 33.0609C16.044 34.3143 17.7323 35 19.67 35H28.34C30.2779 35 31.9642 34.3141 33.1639 33.06C34.3598 31.8098 35 30.0713 35 28.09V19.92C35 17.9344 34.3602 16.1934 33.1643 14.9417C31.9645 13.6859 30.278 13 28.34 13H22Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-header': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M42 31.812L42 16.206C42 10.104 37.716 6 31.344 6L16.638 6C10.284 6 6 10.104 6 16.206L6 31.812C6 37.914 10.284 42 16.638 42L31.344 42C37.716 42 42 37.914 42 31.812Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect
          x="35"
          y="14"
          width="8"
          height="22"
          rx="3"
          transform="rotate(90 35 14)"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle cx="31" cy="18" r="1" fill="currentColor" />
        <rect x="28" y="17" width="2" height="12" rx="1" transform="rotate(90 28 17)" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 21L13 28.09C13 30.0725 13.6435 31.8112 14.842 33.0609C16.044 34.3143 17.7323 35 19.67 35L28.34 35C30.2779 35 31.9642 34.3141 33.1639 33.06C34.3598 31.8098 35 30.0713 35 28.09L35 21L33 21L33 28.09C33 29.6387 32.5052 30.8552 31.7186 31.6775C30.9358 32.4959 29.7921 33 28.34 33L19.67 33C18.2177 33 17.071 32.4957 16.2855 31.6766C15.4965 30.8538 15 29.6375 15 28.09L15 21L13 21Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-icon': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.2853 14H31.5519C32.9035 14 33.9998 15.1059 33.9998 16.4702V19.7641C33.9998 21.1274 32.9035 22.2343 31.5519 22.2343H28.2853C26.9328 22.2343 25.8364 21.1274 25.8364 19.7641V16.4702C25.8364 15.1059 26.9328 14 28.2853 14Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4489 14H19.7145C21.067 14 22.1634 15.1059 22.1634 16.4702V19.7641C22.1634 21.1274 21.067 22.2343 19.7145 22.2343H16.4489C15.0964 22.2343 14 21.1274 14 19.7641V16.4702C14 15.1059 15.0964 14 16.4489 14Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.4489 25.7657H19.7145C21.067 25.7657 22.1634 26.8716 22.1634 28.237V31.5299C22.1634 32.8941 21.067 34 19.7145 34H16.4489C15.0964 34 14 32.8941 14 31.5299V28.237C14 26.8716 15.0964 25.7657 16.4489 25.7657Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.2853 25.7657H31.5519C32.9035 25.7657 33.9998 26.8716 33.9998 28.237V31.5299C33.9998 32.8941 32.9035 34 31.5519 34H28.2853C26.9328 34 25.8364 32.8941 25.8364 31.5299V28.237C25.8364 26.8716 26.9328 25.7657 28.2853 25.7657Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'component-image': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.6649 19.5207C21.6649 20.7905 20.6344 21.8211 19.3646 21.8211C18.096 21.8211 17.0654 20.7905 17.0654 19.5207C17.0654 18.2509 18.096 17.2203 19.3646 17.2203C20.6344 17.2203 21.6649 18.2509 21.6649 19.5207Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.7539 27.2031C33.5152 26.1252 32.4373 24.828 31.0167 23.9719C29.5936 23.1158 28.0646 23.6441 27.0776 24.9214C26.1243 26.1564 25.5287 27.8175 24.0894 28.5963C22.3161 29.5571 21.2744 28.0081 19.7952 27.3875C18.1441 26.6959 16.8904 27.9396 15.9259 29.1346C14.9602 30.3309 13.982 31.5148 13 32.6986"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'component-line-chart': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="34" y="29" width="2" height="20" rx="1" transform="rotate(90 34 29)" fill="currentColor" />
        <rect x="19" y="31" width="2" height="17" rx="1" transform="rotate(-180 19 31)" fill="currentColor" />
        <circle cx="22" cy="26" r="2" fill="currentColor" />
        <circle cx="30" cy="19" r="2" fill="currentColor" />
        <path
          d="M22 26L22.7609 23.4636C23.1357 22.2142 24.587 21.6522 25.7056 22.3233L26.2944 22.6767C27.413 23.3478 28.8643 22.7858 29.2391 21.5364L30 19"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    ),
  },
  'component-list': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M42 31.812L42 16.206C42 10.104 37.716 6 31.344 6L16.638 6C10.284 6 6 10.104 6 16.206L6 31.812C6 37.914 10.284 42 16.638 42L31.344 42C37.716 42 42 37.914 42 31.812Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <circle cx="19" cy="21" r="2" fill="currentColor" />
        <circle cx="19" cy="27" r="2" fill="currentColor" />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M34 21.5L23 21.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34 27.5L23 27.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'component-maps': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M42 31.812L42 16.206C42 10.104 37.716 6 31.344 6L16.638 6C10.284 6 6 10.104 6 16.206L6 31.812C6 37.914 10.284 42 16.638 42L31.344 42C37.716 42 42 37.914 42 31.812Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 18.9796C18.0113 15.6659 20.7067 12.9888 24.0204 13C27.3341 13.0113 30.0112 15.7067 30 19.0204V19.0884C29.9592 21.2424 28.7565 23.2333 27.282 24.7894C26.4387 25.665 25.497 26.4403 24.4756 27.0997C24.2025 27.3359 23.7974 27.3359 23.5243 27.0997C22.0017 26.1086 20.6654 24.8574 19.5764 23.4032C18.6059 22.1351 18.0548 20.596 18 19V18.9796Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="23.9999"
          cy="19.0952"
          r="1.92298"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="28" y="29" width="2" height="8" rx="1" transform="rotate(90 28 29)" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33 30L33 28C33 26.3431 31.6569 25 30 25L28 25L28 23L30 23C32.7614 23 35 25.2386 35 28L35 30C35 32.7614 32.7614 35 30 35L18 35C15.2386 35 13 32.7614 13 30L13 28C13 25.2386 15.2386 23 18 23L28 23L20 23L20 25L18 25C16.3431 25 15 26.3431 15 28L15 30C15 31.6569 16.3431 33 18 33L30 33C31.6569 33 33 31.6569 33 30Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-menu': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M42 31.812L42 16.206C42 10.104 37.716 6 31.344 6L16.638 6C10.284 6 6 10.104 6 16.206L6 31.812C6 37.914 10.284 42 16.638 42L31.344 42C37.716 42 42 37.914 42 31.812Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="30" y="18" width="2" height="12" rx="1" transform="rotate(90 30 18)" fill="currentColor" />
        <rect x="30" y="23" width="2" height="12" rx="1" transform="rotate(90 30 23)" fill="currentColor" />
        <rect x="30" y="28" width="2" height="12" rx="1" transform="rotate(90 30 28)" fill="currentColor" />
      </svg>
    ),
  },
  'component-mutation-container': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.5732 21.8384C25.1255 21.8384 25.5732 21.3907 25.5732 20.8384C25.5732 20.2861 25.1255 19.8384 24.5732 19.8384L20.4215 19.8384L21.5563 18.7087C21.9477 18.3191 21.9492 17.6859 21.5596 17.2945C21.1699 16.9031 20.5368 16.9016 20.1453 17.2913L17.2943 20.1293C17.1058 20.3169 16.9999 20.5719 16.9998 20.8379C16.9998 20.9471 17.0177 21.0544 17.0517 21.156C17.0723 21.2173 17.0986 21.276 17.13 21.3314C17.1744 21.4096 17.2294 21.4821 17.2942 21.5466L20.1452 24.3856C20.5366 24.7753 21.1697 24.774 21.5594 24.3826C21.9491 23.9913 21.9478 23.3581 21.5564 22.9684L20.4216 21.8384L24.5732 21.8384Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8416 14.9408C16.0437 13.6858 17.7322 13 19.67 13H28.34C30.278 13 31.9645 13.6859 33.1643 14.9417C34.3602 16.1934 35 17.9344 35 19.92V24.7642C35.1634 24.8859 35.3172 25.0217 35.46 25.1712C36.1881 25.9332 36.56 26.9756 36.56 28.1258V32.4395C36.56 33.5877 36.1876 34.6289 35.4596 35.3899C34.7278 36.155 33.7094 36.56 32.5715 36.56H27.9938C26.8561 36.56 25.8368 36.1551 25.1039 35.3909C24.9858 35.2677 24.877 35.1372 24.7776 35H19.67C17.7323 35 16.044 34.3143 14.842 33.0609C13.6435 31.8112 13 30.0725 13 28.09V19.92C13 17.9332 13.6431 16.1921 14.8416 14.9408ZM24.0306 33C24.0102 32.8166 24 32.6296 24 32.4395V28.1258C24 26.9744 24.374 25.9318 25.1035 25.1702C25.8365 24.4049 26.856 24 27.9938 24H32.5715C32.7164 24 32.8593 24.0066 33 24.0196V19.92C33 18.3656 32.5048 17.1466 31.7182 16.3233C30.9355 15.5041 29.792 15 28.34 15H19.67C18.2178 15 17.0713 15.5042 16.2859 16.3242C15.4969 17.1479 15 18.3668 15 19.92V28.09C15 29.6375 15.4965 30.8538 16.2855 31.6766C17.071 32.4957 18.2177 33 19.67 33H24.0306ZM26 28.1258C26 27.408 26.2279 26.8877 26.5478 26.5537C26.8642 26.2234 27.3416 26 27.9938 26H32.5715C33.2235 26 33.6991 26.2232 34.0139 26.5528C34.3327 26.8863 34.56 27.4068 34.56 28.1258V32.4395C34.56 33.1552 34.3331 33.6742 34.0144 34.0075C33.6994 34.3367 33.2236 34.56 32.5715 34.56H27.9938C27.3415 34.56 26.8639 34.3365 26.5474 34.0065C26.2275 33.6729 26 33.154 26 32.4395V28.1258Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-pie-chart': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <mask
          id="path-2-outside-1_5091_812"
          maskUnits="userSpaceOnUse"
          x="12"
          y="12"
          width="24"
          height="24"
          fill="black"
        >
          <rect fill="white" x="12" y="12" width="24" height="24" />
          <path d="M32 24C33.1046 24 34.0201 24.9042 33.8007 25.9867C33.5434 27.2555 33.041 28.4687 32.3147 29.5557C31.2159 31.2002 29.6541 32.4819 27.8268 33.2388C25.9996 33.9957 23.9889 34.1937 22.0491 33.8079C20.1093 33.422 18.3275 32.4696 16.9289 31.0711C15.5304 29.6725 14.578 27.8907 14.1921 25.9509C13.8063 24.0111 14.0043 22.0004 14.7612 20.1732C15.5181 18.3459 16.7998 16.7841 18.4443 15.6853C19.5313 14.959 20.7445 14.4566 22.0133 14.1993C23.0958 13.9799 24 14.8954 24 16L24 22C24 23.1046 24.8954 24 26 24H32Z" />
        </mask>
        <path
          d="M32 24C33.1046 24 34.0201 24.9042 33.8007 25.9867C33.5434 27.2555 33.041 28.4687 32.3147 29.5557C31.2159 31.2002 29.6541 32.4819 27.8268 33.2388C25.9996 33.9957 23.9889 34.1937 22.0491 33.8079C20.1093 33.422 18.3275 32.4696 16.9289 31.0711C15.5304 29.6725 14.578 27.8907 14.1921 25.9509C13.8063 24.0111 14.0043 22.0004 14.7612 20.1732C15.5181 18.3459 16.7998 16.7841 18.4443 15.6853C19.5313 14.959 20.7445 14.4566 22.0133 14.1993C23.0958 13.9799 24 14.8954 24 16L24 22C24 23.1046 24.8954 24 26 24H32Z"
          stroke="currentColor"
          strokeWidth="4"
          mask="url(#path-2-outside-1_5091_812)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.5145 15C32.5145 14.4477 32.0668 14 31.5145 14C30.9623 14 30.5145 14.4477 30.5145 15V16.3676H29.147C28.5947 16.3676 28.147 16.8154 28.147 17.3676C28.147 17.9199 28.5947 18.3676 29.147 18.3676H30.5145V19.7352C30.5145 20.2875 30.9623 20.7352 31.5145 20.7352C32.0668 20.7352 32.5145 20.2875 32.5145 19.7352V18.3676H33.8822C34.4345 18.3676 34.8822 17.9199 34.8822 17.3676C34.8822 16.8154 34.4345 16.3676 33.8822 16.3676H32.5145V15Z"
          fill="currentColor"
        />
        <path d="M25 20L25 35" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  'component-progress': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect
          x="30"
          y="24"
          width="5"
          height="12"
          rx="2"
          transform="rotate(90 30 24)"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path d="M28 24L23 29" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path
          d="M19 18.0769V18.9231H20.5495L19.3407 21.9231H20.2747L21.5275 18.8132V18.0769H19Z"
          fill="currentColor"
        />
        <path
          d="M23.0382 19.4286H22.7251L22.7635 18.9011H24.1646V18.0769H21.9393L21.78 20.2857H22.9833C23.3185 20.2857 23.4778 20.478 23.4778 20.7143C23.4778 20.9505 23.3185 21.1429 22.9558 21.1429C22.5932 21.1429 22.4284 20.989 22.3404 20.7363L21.5822 21.1758C21.8185 21.7418 22.3459 22 22.9558 22C23.6976 22 24.3569 21.5604 24.3569 20.7143C24.3569 19.8681 23.7525 19.4286 23.0382 19.4286Z"
          fill="currentColor"
        />
        <path
          d="M25.5617 19.8681C26.1057 19.8681 26.5123 19.4505 26.5123 18.9341C26.5123 18.4011 26.1057 18 25.5617 18C25.0123 18 24.6057 18.4176 24.6057 18.9341C24.6057 19.4505 25.0123 19.8681 25.5617 19.8681ZM25.0617 21.3187L25.4244 21.533L27.9079 18.7802L27.5452 18.5714L25.0617 21.3187ZM25.5562 19.2363C25.3859 19.2363 25.265 19.1044 25.265 18.9341C25.265 18.7637 25.3859 18.6319 25.5562 18.6319C25.7321 18.6319 25.8529 18.7637 25.8529 18.9341C25.8529 19.0934 25.7321 19.2363 25.5562 19.2363ZM27.5233 21.989C28.0672 21.989 28.4738 21.5714 28.4738 21.0549C28.4738 20.5385 28.0672 20.1209 27.5233 20.1209C26.9738 20.1209 26.5672 20.5385 26.5672 21.0549C26.5672 21.5714 26.9738 21.989 27.5233 21.989ZM27.5178 21.3571C27.3474 21.3571 27.2266 21.2253 27.2266 21.0549C27.2266 20.8846 27.3474 20.7527 27.5178 20.7527C27.6936 20.7527 27.8145 20.8846 27.8145 21.0549C27.8145 21.2143 27.6936 21.3571 27.5178 21.3571Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-rich-text-editor': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M18.1945 29.3C18.4878 29.2733 18.7012 29.2333 18.8345 29.18C18.9678 29.1267 19.0578 29.04 19.1045 28.92C19.1578 28.7933 19.1845 28.6 19.1845 28.34V24.52C18.8912 24.5267 18.6812 24.56 18.5545 24.62C18.4278 24.68 18.3345 24.7967 18.2745 24.97C18.2212 25.1367 18.1745 25.43 18.1345 25.85L17.1345 25.92C17.1878 25.14 17.2212 24.3567 17.2345 23.57L17.3545 23.45L18.4345 23.56H21.5545L22.6645 23.45L22.7745 23.57C22.8012 24.6033 22.8278 25.3633 22.8545 25.85L21.8545 25.92C21.8078 25.46 21.7578 25.1433 21.7045 24.97C21.6578 24.79 21.5745 24.6733 21.4545 24.62C21.3412 24.56 21.1412 24.5267 20.8545 24.52C20.8012 25.8533 20.7745 27.1967 20.7745 28.55C20.7745 28.7967 20.8145 28.9733 20.8945 29.08C20.9812 29.18 21.1212 29.23 21.3145 29.23C21.4545 29.23 21.6278 29.22 21.8345 29.2L21.8745 29.26L21.7845 30.05C20.8045 30.0167 20.1845 30 19.9245 30C19.4645 30 18.8612 30.0233 18.1145 30.07L18.1945 29.3Z"
          fill="currentColor"
        />
        <path
          d="M22.742 14.7891H19.003C15.928 14.7891 14 16.9661 14 20.0481V28.3621C14 31.4441 15.919 33.6211 19.003 33.6211H27.827C30.912 33.6211 32.831 31.4441 32.831 28.3621V24.3341"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.5405 19.0835L30.0808 13.5193C30.7711 12.8269 31.8898 12.8269 32.5801 13.5193L33.4823 14.4255C34.1726 15.1187 34.1726 16.243 33.4823 16.9354L27.9153 22.5265C27.6135 22.8295 27.2043 23 26.7772 23H24L24.0697 20.1855C24.0801 19.7715 24.2484 19.3769 24.5405 19.0835Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29 15L32 18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'component-sidebar': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.2853 14H31.5519C32.9035 14 33.9998 15.1059 33.9998 16.4702V19.7641C33.9998 21.1274 32.9035 22.2343 31.5519 22.2343H28.2853C26.9328 22.2343 25.8364 21.1274 25.8364 19.7641V16.4702C25.8364 15.1059 26.9328 14 28.2853 14Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.2853 25.7657H31.5519C32.9035 25.7657 33.9998 26.8716 33.9998 28.237V31.5299C33.9998 32.8941 32.9035 34 31.5519 34H28.2853C26.9328 34 25.8364 32.8941 25.8364 31.5299V28.237C25.8364 26.8716 26.9328 25.7657 28.2853 25.7657Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="15" y="14" width="7" height="20" rx="2" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  'component-stories': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.3676 18C28.3676 17.4477 27.9199 17 27.3676 17C26.8153 17 26.3676 17.4477 26.3676 18V19.3676H25C24.4477 19.3676 24 19.8154 24 20.3676C24 20.9199 24.4477 21.3676 25 21.3676H26.3676V22.7352C26.3676 23.2875 26.8153 23.7352 27.3676 23.7352C27.9199 23.7352 28.3676 23.2875 28.3676 22.7352V21.3676H29.7352C30.2875 21.3676 30.7352 20.9199 30.7352 20.3676C30.7352 19.8154 30.2875 19.3676 29.7352 19.3676H28.3676V18Z"
          fill="currentColor"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2054 29.1788L22.9454 30.0938C23.1084 30.1788 23.2994 30.0407 23.2684 29.8597L22.9354 27.9207L24.3444 26.5498C24.4764 26.4208 24.4034 26.1977 24.2214 26.1707L22.2754 25.8878L21.4044 24.1238C21.3234 23.9587 21.0884 23.9587 21.0064 24.1238L20.1354 25.8878L18.1904 26.1707C18.0084 26.1977 17.9354 26.4208 18.0674 26.5498L19.4754 27.9207L19.1424 29.8597C19.1114 30.0407 19.3024 30.1788 19.4654 30.0938L21.2054 29.1788Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="21" y="19" width="2" height="7" rx="1" transform="rotate(90 21 19)" fill="currentColor" />
        <rect x="34" y="28" width="2" height="7" rx="1" transform="rotate(90 34 28)" fill="currentColor" />
      </svg>
    ),
  },
  'component-table': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M28.34 14H19.67C16.28 14 14 16.38 14 19.92V28.09C14 31.62 16.28 34 19.67 34H28.34C31.73 34 34 31.62 34 28.09V19.92C34 16.38 31.73 14 28.34 14Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect x="19" y="14" width="2" height="20" rx="1" fill="currentColor" />
        <rect x="34" y="19" width="2" height="20" rx="1" transform="rotate(90 34 19)" fill="currentColor" />
        <rect x="27" y="14" width="2" height="20" rx="1" fill="currentColor" />
        <rect x="34" y="27" width="2" height="20" rx="1" transform="rotate(90 34 27)" fill="currentColor" />
      </svg>
    ),
  },
  'component-title': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M14.1945 19.3C14.4878 19.2733 14.7012 19.2333 14.8345 19.18C14.9678 19.1267 15.0578 19.04 15.1045 18.92C15.1578 18.7933 15.1845 18.6 15.1845 18.34V14.52C14.8912 14.5267 14.6812 14.56 14.5545 14.62C14.4278 14.68 14.3345 14.7967 14.2745 14.97C14.2212 15.1367 14.1745 15.43 14.1345 15.85L13.1345 15.92C13.1878 15.14 13.2212 14.3567 13.2345 13.57L13.3545 13.45L14.4345 13.56H17.5545L18.6645 13.45L18.7745 13.57C18.8012 14.6033 18.8278 15.3633 18.8545 15.85L17.8545 15.92C17.8078 15.46 17.7578 15.1433 17.7045 14.97C17.6578 14.79 17.5745 14.6733 17.4545 14.62C17.3412 14.56 17.1412 14.5267 16.8545 14.52C16.8012 15.8533 16.7745 17.1967 16.7745 18.55C16.7745 18.7967 16.8145 18.9733 16.8945 19.08C16.9812 19.18 17.1212 19.23 17.3145 19.23C17.4545 19.23 17.6278 19.22 17.8345 19.2L17.8745 19.26L17.7845 20.05C16.8045 20.0167 16.1845 20 15.9245 20C15.4645 20 14.8612 20.0233 14.1145 20.07L14.1945 19.3Z"
          fill="currentColor"
        />
        <path
          d="M34 28.5L14 28.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34 23.5L14 23.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34 33.5L14 33.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'component-text': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M20.389 29.6C20.9757 29.5467 21.4023 29.4667 21.669 29.36C21.9357 29.2533 22.1157 29.08 22.209 28.84C22.3157 28.5867 22.369 28.2 22.369 27.68V20.04C21.7823 20.0533 21.3623 20.12 21.109 20.24C20.8557 20.36 20.669 20.5933 20.549 20.94C20.4423 21.2733 20.349 21.86 20.269 22.7L18.269 22.84C18.3757 21.28 18.4423 19.7133 18.469 18.14L18.709 17.9L20.869 18.12H27.109L29.329 17.9L29.549 18.14C29.6023 20.2067 29.6557 21.7267 29.709 22.7L27.709 22.84C27.6157 21.92 27.5157 21.2867 27.409 20.94C27.3157 20.58 27.149 20.3467 26.909 20.24C26.6823 20.12 26.2823 20.0533 25.709 20.04C25.6023 22.7067 25.549 25.3933 25.549 28.1C25.549 28.5933 25.629 28.9467 25.789 29.16C25.9623 29.36 26.2423 29.46 26.629 29.46C26.909 29.46 27.2557 29.44 27.669 29.4L27.749 29.52L27.569 31.1C25.609 31.0333 24.369 31 23.849 31C22.929 31 21.7223 31.0467 20.229 31.14L20.389 29.6Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'component-word-cloud': {
    viewBox: '0 0 48 48',
    path: (
      <svg width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M31.812 6H16.206C10.104 6 6 10.284 6 16.656V31.362C6 37.716 10.104 42 16.206 42H31.812C37.914 42 42 37.716 42 31.362V16.656C42 10.284 37.914 6 31.812 6Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M22.1945 25.3C22.4878 25.2733 22.7012 25.2333 22.8345 25.18C22.9678 25.1267 23.0578 25.04 23.1045 24.92C23.1578 24.7933 23.1845 24.6 23.1845 24.34V20.52C22.8912 20.5267 22.6812 20.56 22.5545 20.62C22.4278 20.68 22.3345 20.7967 22.2745 20.97C22.2212 21.1367 22.1745 21.43 22.1345 21.85L21.1345 21.92C21.1878 21.14 21.2212 20.3567 21.2345 19.57L21.3545 19.45L22.4345 19.56H25.5545L26.6645 19.45L26.7745 19.57C26.8012 20.6033 26.8278 21.3633 26.8545 21.85L25.8545 21.92C25.8078 21.46 25.7578 21.1433 25.7045 20.97C25.6578 20.79 25.5745 20.6733 25.4545 20.62C25.3412 20.56 25.1412 20.5267 24.8545 20.52C24.8012 21.8533 24.7745 23.1967 24.7745 24.55C24.7745 24.7967 24.8145 24.9733 24.8945 25.08C24.9812 25.18 25.1212 25.23 25.3145 25.23C25.4545 25.23 25.6278 25.22 25.8345 25.2L25.8745 25.26L25.7845 26.05C24.8045 26.0167 24.1845 26 23.9245 26C23.4645 26 22.8612 26.0233 22.1145 26.07L22.1945 25.3Z"
          fill="currentColor"
        />
        <path
          d="M34 33.5L14 33.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8611 20.3146C17.8527 20.2191 17.8527 20.1236 17.8527 20.0281C17.8527 17.2492 20.4691 15 23.6952 15C26.5402 15 28.9111 16.7542 29.4276 19.0728H29.6478C32.0525 19.0728 34 21.0701 34 23.5364C34 26.0027 32.0525 28 29.6478 28H17.7426C15.6765 28 14 26.2806 14 24.1617C14 22.0428 15.6765 20.3233 17.7426 20.3233C17.7426 20.3146 17.8611 20.3146 17.8611 20.3146Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  data: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="none"
          d="M6.33333 6V6.0125M0.999999 6C0.999999 4.67392 1.5619 3.40215 2.5621 2.46447C3.56229 1.52678 4.91884 1 6.33333 1L22.3333 1C23.0406 1 23.7189 1.26339 24.219 1.73223C24.719 2.20107 25 2.83696 25 3.5V8.5C25 9.16304 24.719 9.79893 24.219 10.2678C23.7189 10.7366 23.0406 11 22.3333 11L6.33333 11C4.91884 11 3.56229 10.4732 2.5621 9.53553C1.5619 8.59785 0.999999 7.32608 0.999999 6Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fill="none"
          d="M6.33333 20V20.0125M0.999999 20C0.999999 18.6739 1.5619 17.4021 2.5621 16.4645C3.56229 15.5268 4.91884 15 6.33333 15L22.3333 15C23.0406 15 23.7189 15.2634 24.219 15.7322C24.719 16.2011 25 16.837 25 17.5V22.5C25 23.163 24.719 23.7989 24.219 24.2678C23.7189 24.7366 23.0406 25 22.3333 25L6.33333 25C4.91884 25 3.56229 24.4732 2.5621 23.5355C1.5619 22.5979 0.999999 21.3261 0.999999 20Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 26 26',
  },
  'datafield-date': {
    viewBox: '0 0 20 22',
    path: (
      <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.09253 8.40427H18.9165"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.442 12.3097H14.4512"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0047 12.3097H10.014"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.55793 12.3097H5.5672"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.442 16.1962H14.4512"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0047 16.1962H10.014"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.55793 16.1962H5.5672"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0438 1V4.29078"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.9654 1V4.29078"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.2383 2.57922H5.77096C2.83427 2.57922 1 4.21516 1 7.22225V16.2719C1 19.3263 2.83427 21 5.77096 21H14.229C17.175 21 19 19.3546 19 16.3475V7.22225C19.0092 4.21516 17.1842 2.57922 14.2383 2.57922Z"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-email': {
    viewBox: '0 0 21 20',
    path: (
      <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.2678 7.0611L12.0024 10.4954C11.1952 11.1282 10.0636 11.1282 9.25641 10.4954L4.95435 7.0611"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.88787 1.5H15.3158C16.6752 1.51525 17.969 2.08993 18.896 3.0902C19.823 4.09048 20.3022 5.42903 20.222 6.79412V13.322C20.3022 14.6871 19.823 16.0256 18.896 17.0259C17.969 18.0262 16.6752 18.6009 15.3158 18.6161H5.88787C2.96796 18.6161 1 16.2407 1 13.322V6.79412C1 3.87545 2.96796 1.5 5.88787 1.5Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-file': {
    viewBox: '0 0 24 24',
    path: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.4383 11.6622L12.2483 20.8522C11.1225 21.9781 9.59552 22.6106 8.00334 22.6106C6.41115 22.6106 4.88418 21.9781 3.75834 20.8522C2.63249 19.7264 2 18.1994 2 16.6072C2 15.015 2.63249 13.4881 3.75834 12.3622L12.9483 3.17222C13.6989 2.42166 14.7169 2 15.7783 2C16.8398 2 17.8578 2.42166 18.6083 3.17222C19.3589 3.92279 19.7806 4.94077 19.7806 6.00222C19.7806 7.06368 19.3589 8.08166 18.6083 8.83222L9.40834 18.0222C9.03305 18.3975 8.52406 18.6083 7.99334 18.6083C7.46261 18.6083 6.95362 18.3975 6.57834 18.0222C6.20305 17.6469 5.99222 17.138 5.99222 16.6072C5.99222 16.0765 6.20305 15.5675 6.57834 15.1922L15.0683 6.71222"
          stroke="#181621"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-list': {
    viewBox: '0 0 20 17',
    path: (
      <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 2.5H19" stroke="#200E32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 2.5C1 3.32904 1.67157 4 2.5 4C3.32843 4 4 3.32904 4 2.5C4 1.67157 3.32843 1 2.5 1C1.67157 1 1 1.67157 1 2.5Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8 8.5H19" stroke="#200E32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 8.5C1 9.32904 1.67157 10 2.5 10C3.32843 10 4 9.32904 4 8.5C4 7.67157 3.32843 7 2.5 7C1.67157 7 1 7.67157 1 8.5Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 14.5H19"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 14.5C1 15.329 1.67157 16 2.5 16C3.32843 16 4 15.329 4 14.5C4 13.6716 3.32843 13 2.5 13C1.67157 13 1 13.6716 1 14.5Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-id': {
    viewBox: '0 0 20 20',
    path: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3344 0.750183H5.66537C2.64437 0.750183 0.750366 2.88918 0.750366 5.91618V14.0842C0.750366 17.1112 2.63537 19.2502 5.66537 19.2502H14.3334C17.3644 19.2502 19.2504 17.1112 19.2504 14.0842V5.91618C19.2504 2.88918 17.3644 0.750183 14.3344 0.750183Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.69226 10.0002C8.69226 11.0222 7.86326 11.8522 6.84026 11.8522C5.81826 11.8522 4.98926 11.0222 4.98926 10.0002C4.98926 8.97819 5.81826 8.14819 6.84026 8.14819C7.86326 8.14819 8.69226 8.97819 8.69226 10.0002Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.69226 10.0002H15.0103V11.8522"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.1815 11.8517V9.99969"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-image': {
    viewBox: '0 0 20 20',
    path: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3034 0.750305H5.65437C2.63937 0.750305 0.750366 2.88431 0.750366 5.9043V14.0533C0.750366 17.0733 2.63137 19.2073 5.65437 19.2073H14.3024C17.3264 19.2073 19.2074 17.0733 19.2074 14.0533V5.9043C19.2074 2.88431 17.3264 0.750305 14.3034 0.750305Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.70321 6.78551C8.70321 7.80451 7.87621 8.63151 6.85721 8.63151C5.83921 8.63151 5.01221 7.80451 5.01221 6.78551C5.01221 5.76651 5.83921 4.93951 6.85721 4.93951C7.87621 4.93951 8.70321 5.76651 8.70321 6.78551Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.2066 12.9505C18.2126 12.0855 17.3476 11.0445 16.2076 10.3575C15.0656 9.67054 13.8386 10.0945 13.0466 11.1195C12.2816 12.1105 11.8036 13.4435 10.6486 14.0685C9.22563 14.8395 8.38963 13.5965 7.20263 13.0985C5.87763 12.5435 4.87163 13.5415 4.09763 14.5005C3.32263 15.4605 2.53763 16.4105 1.74963 17.3605"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-geolocation': {
    viewBox: '0 0 18 21',
    path: (
      <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.23901 9.39129C1.25342 5.15071 4.70278 1.72471 8.94336 1.73912C13.1839 1.75353 16.6099 5.20288 16.5955 9.44347V9.53042C16.5434 12.2869 15.0042 14.8348 13.1173 16.8261C12.0381 17.9467 10.833 18.9388 9.52597 19.7826C9.17648 20.0849 8.65807 20.0849 8.30858 19.7826C6.36008 18.5143 4.64995 16.9131 3.2564 15.0522C2.01436 13.4294 1.30918 11.4597 1.23901 9.41738L1.23901 9.39129Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="8.91717"
          cy="9.53912"
          r="2.46087"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-number': {
    viewBox: '0 0 18 8',
    path: (
      <svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-outside-1" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="8" fill="black">
          <rect fill="white" width="18" height="8" />
          <path d="M2.74316 1V6.68604H3.75586V7.23804H1.10376V6.68604H2.14136V1.72217L1 1.85083V1.42334C1.24072 1.3597 1.46623 1.29191 1.67651 1.21997C1.8868 1.14803 2.0791 1.07471 2.25342 1H2.74316ZM5.84351 7.23804V6.3042H6.66943V7.23804H5.84351ZM7.95605 7.23804V6.66113C8.09163 6.35677 8.26872 6.06348 8.4873 5.78125C8.70866 5.49626 8.98258 5.21126 9.30908 4.92627C9.45573 4.79622 9.68953 4.61499 10.0105 4.38257C10.3342 4.14738 10.5597 3.96338 10.687 3.83057C10.8835 3.62305 11.0273 3.42798 11.1187 3.24536C11.21 3.05998 11.2556 2.87183 11.2556 2.68091C11.2556 2.32674 11.1505 2.04728 10.9402 1.84253C10.7327 1.63778 10.4463 1.5354 10.0811 1.5354C9.70752 1.5354 9.39486 1.64884 9.14307 1.87573C8.89404 2.10262 8.72526 2.42773 8.63672 2.85107L8.04321 2.72656C8.16496 2.15934 8.40015 1.73047 8.74878 1.43994C9.09741 1.14665 9.54704 1 10.0977 1C10.6566 1 11.0979 1.14941 11.4216 1.44824C11.7481 1.7443 11.9114 2.14689 11.9114 2.65601C11.9114 2.87183 11.8851 3.06828 11.8325 3.24536C11.7799 3.41968 11.6983 3.58293 11.5876 3.73511C11.3746 4.0367 10.9374 4.43237 10.2761 4.92212C10.1295 5.02726 10.0202 5.1075 9.94824 5.16284C9.59961 5.4257 9.31185 5.68302 9.08496 5.93481C8.85807 6.18384 8.69206 6.42871 8.58691 6.66943H11.9114V7.23804H7.95605ZM12.9448 6.11743L13.4719 5.7522C13.6601 6.09253 13.8911 6.34985 14.165 6.52417C14.439 6.69849 14.7489 6.78564 15.0947 6.78564C15.5236 6.78564 15.8584 6.67773 16.0991 6.46191C16.3426 6.24333 16.4644 5.94035 16.4644 5.55298C16.4644 5.12134 16.3136 4.79484 16.012 4.57349C15.7131 4.34937 15.2704 4.2373 14.6838 4.2373C14.6008 4.2373 14.522 4.23869 14.4473 4.24146C14.3753 4.24422 14.2992 4.24837 14.219 4.25391V3.6687C14.2411 3.6687 14.2743 3.67008 14.3186 3.67285C14.4957 3.68115 14.6147 3.6853 14.6755 3.6853C15.1985 3.6853 15.5969 3.58569 15.8708 3.38647C16.1448 3.18449 16.2817 2.89258 16.2817 2.51074C16.2817 2.21191 16.1794 1.97673 15.9746 1.80518C15.7726 1.63086 15.4959 1.5437 15.1445 1.5437C14.8568 1.5437 14.5994 1.61149 14.3726 1.74707C14.1457 1.88265 13.9299 2.09847 13.7251 2.39453L13.2395 2.0293C13.4941 1.68066 13.7804 1.42196 14.0986 1.25317C14.4168 1.08439 14.7738 1 15.1694 1C15.7062 1 16.1337 1.13558 16.4519 1.40674C16.7701 1.67513 16.9292 2.03483 16.9292 2.48584C16.9292 2.82617 16.849 3.11808 16.6885 3.36157C16.5308 3.60506 16.297 3.79183 15.9871 3.92188C16.3606 4.06576 16.6428 4.27189 16.8337 4.54028C17.0274 4.80591 17.1243 5.1241 17.1243 5.49487C17.1243 6.05656 16.943 6.5048 16.5806 6.8396C16.2209 7.1744 15.7339 7.3418 15.1196 7.3418C14.6354 7.3418 14.2093 7.23942 13.8413 7.03467C13.4761 6.82715 13.1772 6.5214 12.9448 6.11743Z" />
        </mask>
        <path
          d="M2.74316 1V6.68604H3.75586V7.23804H1.10376V6.68604H2.14136V1.72217L1 1.85083V1.42334C1.24072 1.3597 1.46623 1.29191 1.67651 1.21997C1.8868 1.14803 2.0791 1.07471 2.25342 1H2.74316ZM5.84351 7.23804V6.3042H6.66943V7.23804H5.84351ZM7.95605 7.23804V6.66113C8.09163 6.35677 8.26872 6.06348 8.4873 5.78125C8.70866 5.49626 8.98258 5.21126 9.30908 4.92627C9.45573 4.79622 9.68953 4.61499 10.0105 4.38257C10.3342 4.14738 10.5597 3.96338 10.687 3.83057C10.8835 3.62305 11.0273 3.42798 11.1187 3.24536C11.21 3.05998 11.2556 2.87183 11.2556 2.68091C11.2556 2.32674 11.1505 2.04728 10.9402 1.84253C10.7327 1.63778 10.4463 1.5354 10.0811 1.5354C9.70752 1.5354 9.39486 1.64884 9.14307 1.87573C8.89404 2.10262 8.72526 2.42773 8.63672 2.85107L8.04321 2.72656C8.16496 2.15934 8.40015 1.73047 8.74878 1.43994C9.09741 1.14665 9.54704 1 10.0977 1C10.6566 1 11.0979 1.14941 11.4216 1.44824C11.7481 1.7443 11.9114 2.14689 11.9114 2.65601C11.9114 2.87183 11.8851 3.06828 11.8325 3.24536C11.7799 3.41968 11.6983 3.58293 11.5876 3.73511C11.3746 4.0367 10.9374 4.43237 10.2761 4.92212C10.1295 5.02726 10.0202 5.1075 9.94824 5.16284C9.59961 5.4257 9.31185 5.68302 9.08496 5.93481C8.85807 6.18384 8.69206 6.42871 8.58691 6.66943H11.9114V7.23804H7.95605ZM12.9448 6.11743L13.4719 5.7522C13.6601 6.09253 13.8911 6.34985 14.165 6.52417C14.439 6.69849 14.7489 6.78564 15.0947 6.78564C15.5236 6.78564 15.8584 6.67773 16.0991 6.46191C16.3426 6.24333 16.4644 5.94035 16.4644 5.55298C16.4644 5.12134 16.3136 4.79484 16.012 4.57349C15.7131 4.34937 15.2704 4.2373 14.6838 4.2373C14.6008 4.2373 14.522 4.23869 14.4473 4.24146C14.3753 4.24422 14.2992 4.24837 14.219 4.25391V3.6687C14.2411 3.6687 14.2743 3.67008 14.3186 3.67285C14.4957 3.68115 14.6147 3.6853 14.6755 3.6853C15.1985 3.6853 15.5969 3.58569 15.8708 3.38647C16.1448 3.18449 16.2817 2.89258 16.2817 2.51074C16.2817 2.21191 16.1794 1.97673 15.9746 1.80518C15.7726 1.63086 15.4959 1.5437 15.1445 1.5437C14.8568 1.5437 14.5994 1.61149 14.3726 1.74707C14.1457 1.88265 13.9299 2.09847 13.7251 2.39453L13.2395 2.0293C13.4941 1.68066 13.7804 1.42196 14.0986 1.25317C14.4168 1.08439 14.7738 1 15.1694 1C15.7062 1 16.1337 1.13558 16.4519 1.40674C16.7701 1.67513 16.9292 2.03483 16.9292 2.48584C16.9292 2.82617 16.849 3.11808 16.6885 3.36157C16.5308 3.60506 16.297 3.79183 15.9871 3.92188C16.3606 4.06576 16.6428 4.27189 16.8337 4.54028C17.0274 4.80591 17.1243 5.1241 17.1243 5.49487C17.1243 6.05656 16.943 6.5048 16.5806 6.8396C16.2209 7.1744 15.7339 7.3418 15.1196 7.3418C14.6354 7.3418 14.2093 7.23942 13.8413 7.03467C13.4761 6.82715 13.1772 6.5214 12.9448 6.11743Z"
          fill="#181621"
        />
        <path
          d="M2.74316 1H2.96816C2.96816 0.875736 2.86743 0.775 2.74316 0.775V1ZM2.74316 6.68604H2.51816C2.51816 6.8103 2.6189 6.91104 2.74316 6.91104V6.68604ZM3.75586 6.68604H3.98086C3.98086 6.56177 3.88012 6.46104 3.75586 6.46104V6.68604ZM3.75586 7.23804V7.46304C3.88012 7.46304 3.98086 7.3623 3.98086 7.23804H3.75586ZM1.10376 7.23804H0.87876C0.87876 7.3623 0.979496 7.46304 1.10376 7.46304V7.23804ZM1.10376 6.68604V6.46104C0.979496 6.46104 0.87876 6.56177 0.87876 6.68604H1.10376ZM2.14136 6.68604V6.91104C2.26562 6.91104 2.36636 6.8103 2.36636 6.68604H2.14136ZM2.14136 1.72217H2.36636C2.36636 1.65811 2.33905 1.59708 2.29128 1.55439C2.24351 1.51171 2.17981 1.49141 2.11615 1.49858L2.14136 1.72217ZM1 1.85083H0.775C0.775 1.91489 0.802308 1.97592 0.850077 2.0186C0.897845 2.06129 0.961545 2.08159 1.0252 2.07441L1 1.85083ZM1 1.42334L0.942493 1.20581C0.843768 1.23191 0.775 1.32122 0.775 1.42334H1ZM2.25342 1V0.775C2.22295 0.775 2.19279 0.781189 2.16479 0.793192L2.25342 1ZM5.84351 7.23804H5.61851C5.61851 7.3623 5.71924 7.46304 5.84351 7.46304V7.23804ZM5.84351 6.3042V6.0792C5.71924 6.0792 5.61851 6.17993 5.61851 6.3042H5.84351ZM6.66943 6.3042H6.89443C6.89443 6.17993 6.7937 6.0792 6.66943 6.0792V6.3042ZM6.66943 7.23804V7.46304C6.7937 7.46304 6.89443 7.3623 6.89443 7.23804H6.66943ZM7.95605 7.23804H7.73105C7.73105 7.3623 7.83179 7.46304 7.95605 7.46304V7.23804ZM7.95605 6.66113L7.75052 6.56958C7.73769 6.59839 7.73105 6.62959 7.73105 6.66113H7.95605ZM8.4873 5.78125L8.30961 5.64323L8.30942 5.64348L8.4873 5.78125ZM9.30908 4.92627L9.45705 5.09578L9.45837 5.09461L9.30908 4.92627ZM10.0105 4.38257L10.1425 4.56481L10.1427 4.5646L10.0105 4.38257ZM10.687 3.83057L10.8495 3.98625L10.8504 3.98525L10.687 3.83057ZM11.1187 3.24536L11.3199 3.34599L11.3205 3.34478L11.1187 3.24536ZM10.9402 1.84253L10.7822 2.0027L10.7832 2.00374L10.9402 1.84253ZM9.14307 1.87573L8.99245 1.70858L8.99153 1.70941L9.14307 1.87573ZM8.63672 2.85107L8.59052 3.07128C8.64895 3.08354 8.70985 3.07207 8.75982 3.03941C8.80979 3.00675 8.84473 2.95557 8.85695 2.89714L8.63672 2.85107ZM8.04321 2.72656L7.82322 2.67935C7.81066 2.73787 7.82194 2.79898 7.85455 2.84917C7.88717 2.89936 7.93844 2.93448 7.99702 2.94677L8.04321 2.72656ZM8.74878 1.43994L8.89282 1.61279L8.89363 1.61212L8.74878 1.43994ZM11.4216 1.44824L11.269 1.61358L11.2705 1.61492L11.4216 1.44824ZM11.8325 3.24536L12.0479 3.31033L12.0482 3.3094L11.8325 3.24536ZM11.5876 3.73511L11.4057 3.60276L11.4039 3.60529L11.5876 3.73511ZM10.2761 4.92212L10.4072 5.105L10.41 5.10293L10.2761 4.92212ZM9.94824 5.16284L10.0837 5.34251L10.0854 5.34118L9.94824 5.16284ZM9.08496 5.93481L9.25128 6.08635L9.25211 6.08543L9.08496 5.93481ZM8.58691 6.66943L8.38072 6.57937C8.35034 6.64894 8.35708 6.72913 8.39865 6.79264C8.44022 6.85616 8.51101 6.89443 8.58691 6.89443V6.66943ZM11.9114 6.66943H12.1364C12.1364 6.54517 12.0356 6.44443 11.9114 6.44443V6.66943ZM11.9114 7.23804V7.46304C12.0356 7.46304 12.1364 7.3623 12.1364 7.23804H11.9114ZM12.9448 6.11743L12.8167 5.93249C12.7205 5.9991 12.6915 6.12826 12.7498 6.22964L12.9448 6.11743ZM13.4719 5.7522L13.6688 5.64334C13.6381 5.58766 13.5851 5.54762 13.5232 5.53312C13.4613 5.51862 13.3961 5.53102 13.3438 5.56726L13.4719 5.7522ZM16.0991 6.46191L16.2493 6.62944L16.2494 6.62934L16.0991 6.46191ZM16.012 4.57349L15.877 4.7535L15.8788 4.75487L16.012 4.57349ZM14.4473 4.24146L14.4389 4.01661L14.4386 4.01662L14.4473 4.24146ZM14.219 4.25391H13.994C13.994 4.31627 14.0199 4.37583 14.0655 4.41839C14.1111 4.46094 14.1723 4.48266 14.2345 4.47837L14.219 4.25391ZM14.219 3.6687V3.4437C14.0947 3.4437 13.994 3.54444 13.994 3.6687H14.219ZM14.3186 3.67285L14.3046 3.89744L14.3081 3.8976L14.3186 3.67285ZM15.8708 3.38647L16.0032 3.56844L16.0044 3.56757L15.8708 3.38647ZM15.9746 1.80518L15.8276 1.97553L15.8301 1.97764L15.9746 1.80518ZM13.7251 2.39453L13.5899 2.57435C13.6388 2.61115 13.7006 2.62642 13.761 2.61664C13.8215 2.60686 13.8753 2.57287 13.9102 2.52251L13.7251 2.39453ZM13.2395 2.0293L13.0578 1.89662C12.9852 1.99597 13.0059 2.13517 13.1043 2.20911L13.2395 2.0293ZM16.4519 1.40674L16.306 1.57799L16.3068 1.57873L16.4519 1.40674ZM16.6885 3.36157L16.5006 3.23775L16.4996 3.23925L16.6885 3.36157ZM15.9871 3.92188L15.9 3.7144C15.8153 3.74994 15.7607 3.83338 15.7621 3.92521C15.7634 4.01704 15.8205 4.09883 15.9062 4.13184L15.9871 3.92188ZM16.8337 4.54028L16.6504 4.67071L16.6519 4.67285L16.8337 4.54028ZM16.5806 6.8396L16.4279 6.67432L16.4273 6.6749L16.5806 6.8396ZM13.8413 7.03467L13.7302 7.2303L13.7319 7.23128L13.8413 7.03467ZM2.51816 1V6.68604H2.96816V1H2.51816ZM2.74316 6.91104H3.75586V6.46104H2.74316V6.91104ZM3.53086 6.68604V7.23804H3.98086V6.68604H3.53086ZM3.75586 7.01304H1.10376V7.46304H3.75586V7.01304ZM1.32876 7.23804V6.68604H0.87876V7.23804H1.32876ZM1.10376 6.91104H2.14136V6.46104H1.10376V6.91104ZM2.36636 6.68604V1.72217H1.91636V6.68604H2.36636ZM2.11615 1.49858L0.974796 1.62725L1.0252 2.07441L2.16656 1.94575L2.11615 1.49858ZM1.225 1.85083V1.42334H0.775V1.85083H1.225ZM1.05751 1.64087C1.30279 1.57602 1.53345 1.50672 1.74934 1.43286L1.60368 1.00708C1.39901 1.07711 1.17866 1.14338 0.942493 1.20581L1.05751 1.64087ZM1.74934 1.43286C1.96409 1.35939 2.16175 1.28408 2.34205 1.20681L2.16479 0.793192C1.99645 0.865337 1.80951 0.93667 1.60368 1.00708L1.74934 1.43286ZM2.25342 1.225H2.74316V0.775H2.25342V1.225ZM6.06851 7.23804V6.3042H5.61851V7.23804H6.06851ZM5.84351 6.5292H6.66943V6.0792H5.84351V6.5292ZM6.44443 6.3042V7.23804H6.89443V6.3042H6.44443ZM6.66943 7.01304H5.84351V7.46304H6.66943V7.01304ZM8.18105 7.23804V6.66113H7.73105V7.23804H8.18105ZM8.16159 6.75269C8.28933 6.46591 8.45685 6.18802 8.66519 5.91902L8.30942 5.64348C8.08058 5.93894 7.89394 6.24763 7.75052 6.56958L8.16159 6.75269ZM8.665 5.91927C8.87592 5.64771 9.13935 5.37308 9.45704 5.09578L9.16112 4.75676C8.82582 5.04944 8.5414 5.3448 8.30961 5.64323L8.665 5.91927ZM9.45837 5.09461C9.59635 4.97225 9.82275 4.79632 10.1425 4.56481L9.87853 4.20033C9.55632 4.43366 9.3151 4.6202 9.1598 4.75793L9.45837 5.09461ZM10.1427 4.5646C10.4678 4.32848 10.7073 4.13459 10.8495 3.98625L10.5246 3.67489C10.4122 3.79217 10.2007 3.96628 9.87825 4.20054L10.1427 4.5646ZM10.8504 3.98525C11.0565 3.76756 11.2156 3.55452 11.3199 3.34598L10.9174 3.14474C10.8391 3.30144 10.7104 3.47854 10.5236 3.67588L10.8504 3.98525ZM11.3205 3.34478C11.4258 3.13106 11.4806 2.90908 11.4806 2.68091H11.0306C11.0306 2.83457 10.9942 2.98889 10.9168 3.14595L11.3205 3.34478ZM11.4806 2.68091C11.4806 2.27949 11.3597 1.93698 11.0971 1.68132L10.7832 2.00374C10.9412 2.15758 11.0306 2.37399 11.0306 2.68091H11.4806ZM11.0982 1.68237C10.8386 1.42618 10.4897 1.3104 10.0811 1.3104V1.7604C10.4029 1.7604 10.6268 1.84937 10.7822 2.00269L11.0982 1.68237ZM10.0811 1.3104C9.65803 1.3104 9.28991 1.44054 8.99245 1.70858L9.29368 2.04288C9.4998 1.85715 9.75701 1.7604 10.0811 1.7604V1.3104ZM8.99153 1.70941C8.69875 1.97617 8.51196 2.34853 8.41648 2.80501L8.85695 2.89714C8.93856 2.50694 9.08933 2.22907 9.2946 2.04205L8.99153 1.70941ZM8.68292 2.63087L8.08941 2.50636L7.99702 2.94677L8.59052 3.07128L8.68292 2.63087ZM8.2632 2.77378C8.37737 2.24188 8.59248 1.86307 8.89282 1.61279L8.60474 1.26709C8.20781 1.59786 7.95255 2.0768 7.82322 2.67935L8.2632 2.77378ZM8.89363 1.61212C9.19369 1.35968 9.58852 1.225 10.0977 1.225V0.775C9.50555 0.775 9.00113 0.933612 8.60393 1.26777L8.89363 1.61212ZM10.0977 1.225C10.6158 1.225 10.9971 1.36262 11.269 1.61357L11.5742 1.28291C11.1987 0.936211 10.6974 0.775 10.0977 0.775V1.225ZM11.2705 1.61492C11.5425 1.86156 11.6864 2.19955 11.6864 2.65601H12.1364C12.1364 2.09424 11.9538 1.62705 11.5728 1.28156L11.2705 1.61492ZM11.6864 2.65601C11.6864 2.8537 11.6623 3.02818 11.6168 3.18133L12.0482 3.3094C12.1079 3.10838 12.1364 2.88996 12.1364 2.65601H11.6864ZM11.6171 3.18039C11.5721 3.32973 11.502 3.47032 11.4057 3.60277L11.7696 3.86745C11.8946 3.69554 11.9878 3.50963 12.0479 3.31033L11.6171 3.18039ZM11.4039 3.60529C11.2133 3.87509 10.802 4.25268 10.1422 4.74131L10.41 5.10293C11.0728 4.61207 11.5359 4.19832 11.7714 3.86493L11.4039 3.60529ZM10.145 4.73926C9.9979 4.84474 9.8861 4.92677 9.81106 4.9845L10.0854 5.34118C10.1543 5.28823 10.2611 5.20978 10.4072 5.10498L10.145 4.73926ZM9.81279 4.98318C9.45578 5.25236 9.1566 5.5192 8.91781 5.7842L9.25211 6.08543C9.4671 5.84685 9.74344 5.59904 10.0837 5.3425L9.81279 4.98318ZM8.91864 5.78328C8.67963 6.0456 8.49804 6.31078 8.38072 6.57937L8.7931 6.75949C8.88607 6.54664 9.03651 6.32207 9.25128 6.08635L8.91864 5.78328ZM8.58691 6.89443H11.9114V6.44443H8.58691V6.89443ZM11.6864 6.66943V7.23804H12.1364V6.66943H11.6864ZM11.9114 7.01304H7.95605V7.46304H11.9114V7.01304ZM13.073 6.30237L13.6001 5.93714L13.3438 5.56726L12.8167 5.93249L13.073 6.30237ZM13.275 5.86106C13.4778 6.22783 13.7329 6.51584 14.0442 6.71399L14.2858 6.33435C14.0494 6.18387 13.8424 5.95723 13.6688 5.64334L13.275 5.86106ZM14.0442 6.71399C14.3567 6.9128 14.709 7.01064 15.0947 7.01064V6.56064C14.7887 6.56064 14.5213 6.48417 14.2858 6.33435L14.0442 6.71399ZM15.0947 7.01064C15.5606 7.01064 15.9554 6.89296 16.2493 6.62944L15.9489 6.29439C15.7614 6.46251 15.4866 6.56064 15.0947 6.56064V7.01064ZM16.2494 6.62934C16.5492 6.36019 16.6894 5.99138 16.6894 5.55298H16.2394C16.2394 5.88931 16.136 6.12646 15.9488 6.29448L16.2494 6.62934ZM16.6894 5.55298C16.6894 5.06228 16.5139 4.66278 16.1451 4.3921L15.8788 4.75487C16.1132 4.92691 16.2394 5.18039 16.2394 5.55298H16.6894ZM16.147 4.39349C15.7926 4.12771 15.2932 4.0123 14.6838 4.0123V4.4623C15.2477 4.4623 15.6337 4.57102 15.877 4.75349L16.147 4.39349ZM14.6838 4.0123C14.5984 4.0123 14.5167 4.01373 14.4389 4.01661L14.4556 4.4663C14.5272 4.46365 14.6033 4.4623 14.6838 4.4623V4.0123ZM14.4386 4.01662C14.3642 4.01949 14.2858 4.02377 14.2035 4.02944L14.2345 4.47837C14.3127 4.47298 14.3865 4.46896 14.4559 4.46629L14.4386 4.01662ZM14.444 4.25391V3.6687H13.994V4.25391H14.444ZM14.219 3.8937C14.2338 3.8937 14.2613 3.89471 14.3046 3.89741L14.3326 3.44829C14.2873 3.44546 14.2484 3.4437 14.219 3.4437V3.8937ZM14.3081 3.8976C14.4844 3.90587 14.6086 3.9103 14.6755 3.9103V3.4603C14.6208 3.4603 14.507 3.45643 14.3291 3.4481L14.3081 3.8976ZM14.6755 3.9103C15.2218 3.9103 15.675 3.80712 16.0032 3.56844L15.7385 3.20451C15.5188 3.36426 15.1752 3.4603 14.6755 3.4603V3.9103ZM16.0044 3.56757C16.3434 3.31755 16.5067 2.95401 16.5067 2.51074H16.0567C16.0567 2.83114 15.9461 3.05143 15.7373 3.20538L16.0044 3.56757ZM16.5067 2.51074C16.5067 2.15424 16.3813 1.85241 16.1191 1.63271L15.8301 1.97764C15.9774 2.10104 16.0567 2.26958 16.0567 2.51074H16.5067ZM16.1216 1.63484C15.8673 1.41536 15.5325 1.3187 15.1445 1.3187V1.7687C15.4593 1.7687 15.678 1.84636 15.8276 1.97551L16.1216 1.63484ZM15.1445 1.3187C14.8199 1.3187 14.522 1.39567 14.2571 1.55393L14.488 1.94021C14.6769 1.82731 14.8937 1.7687 15.1445 1.7687V1.3187ZM14.2571 1.55393C13.9946 1.71083 13.7568 1.95307 13.54 2.26655L13.9102 2.52251C14.1029 2.24387 14.2968 2.05447 14.488 1.94021L14.2571 1.55393ZM13.8603 2.21472L13.3747 1.84948L13.1043 2.20911L13.5899 2.57435L13.8603 2.21472ZM13.4212 2.16198C13.6596 1.83547 13.9214 1.6019 14.2041 1.45194L13.9932 1.05441C13.6395 1.24202 13.3285 1.52586 13.0578 1.89662L13.4212 2.16198ZM14.2041 1.45194C14.4867 1.30204 14.8068 1.225 15.1694 1.225V0.775C14.7407 0.775 14.347 0.866746 13.9932 1.05441L14.2041 1.45194ZM15.1694 1.225C15.6683 1.225 16.0389 1.35042 16.306 1.57799L16.5978 1.23549C16.2285 0.920738 15.7442 0.775 15.1694 0.775V1.225ZM16.3068 1.57873C16.5697 1.80048 16.7042 2.09486 16.7042 2.48584H17.1542C17.1542 1.9748 16.9705 1.54978 16.597 1.23475L16.3068 1.57873ZM16.7042 2.48584C16.7042 2.78967 16.633 3.03683 16.5006 3.23775L16.8763 3.48539C17.0649 3.19934 17.1542 2.86267 17.1542 2.48584H16.7042ZM16.4996 3.23925C16.3702 3.43902 16.175 3.59901 15.9 3.7144L16.0741 4.12935C16.4189 3.98465 16.6913 3.7711 16.8773 3.48389L16.4996 3.23925ZM15.9062 4.13184C16.2475 4.26329 16.4901 4.44541 16.6504 4.6707L17.0171 4.40986C16.7955 4.09837 16.4737 3.86822 16.0679 3.71191L15.9062 4.13184ZM16.6519 4.67285C16.814 4.89513 16.8993 5.16539 16.8993 5.49487H17.3493C17.3493 5.08282 17.2408 4.71668 17.0155 4.40772L16.6519 4.67285ZM16.8993 5.49487C16.8993 6.00335 16.7377 6.3882 16.4279 6.67432L16.7332 7.00488C17.1484 6.62141 17.3493 6.10976 17.3493 5.49487H16.8993ZM16.4273 6.6749C16.1189 6.96188 15.6919 7.1168 15.1196 7.1168V7.5668C15.7759 7.5668 16.3228 7.38691 16.7339 7.0043L16.4273 6.6749ZM15.1196 7.1168C14.6679 7.1168 14.2805 7.02156 13.9507 6.83805L13.7319 7.23128C14.1381 7.45728 14.6029 7.5668 15.1196 7.5668V7.1168ZM13.9525 6.83904C13.6258 6.65346 13.3545 6.37832 13.1398 6.00523L12.7498 6.22964C13 6.66449 13.3263 7.00083 13.7302 7.2303L13.9525 6.83904Z"
          fill="#181621"
          mask="url(#path-1-outside-1)"
        />
      </svg>
    ),
  },
  'datafield-phone': {
    viewBox: '0 0 22 22',
    path: (
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.99033 3.87254C2.30665 3.34878 4.0495 1.44376 5.29322 1.50127C5.665 1.53208 5.99364 1.75699 6.26067 2.01784C6.87379 2.61656 8.62897 4.88101 8.72859 5.35753C8.97096 6.52621 7.57833 7.1999 8.00454 8.37783C9.09112 11.0366 10.9634 12.9088 13.6233 13.9943C14.8003 14.4205 15.474 13.0279 16.6428 13.2713C17.1183 13.3709 19.3839 15.126 19.9826 15.7391C20.2425 16.0051 20.4684 16.3347 20.4992 16.7065C20.5454 18.0159 18.5222 19.7833 18.1278 20.0092C17.1974 20.6747 15.9834 20.6634 14.5035 19.9753C10.3739 18.2572 3.77426 11.7822 2.02422 7.49669C1.35461 6.02505 1.30839 4.80297 1.99033 3.87254Z"
          stroke="#200E32"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-collection': {
    viewBox: '0 0 18 16',
    path: (
      <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3.5" y="6.5" width="3" height="3" rx="0.5" transform="rotate(90 3.5 6.5)" stroke="black" />
        <rect x="3.5" y="0.5" width="3" height="3" rx="0.5" transform="rotate(90 3.5 0.5)" stroke="black" />
        <rect x="3.5" y="12.5" width="3" height="3" rx="0.5" transform="rotate(90 3.5 12.5)" stroke="black" />
        <rect x="18" y="6" width="4" height="4" rx="1" transform="rotate(90 18 6)" fill="black" />
        <path d="M4 8H14" stroke="black" />
        <path d="M4 14L8 14C8.55228 14 9 13.5523 9 13L9 3C9 2.44772 8.55228 2 8 2L4 2" stroke="black" />
      </svg>
    ),
  },
  'datafield-richtext': {
    viewBox: '0 0 19 15',
    path: (
      <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="1.25"
          y="1.25"
          width="5.5"
          height="5.5"
          rx="1.25"
          stroke="#181621"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="9.75"
          y1="2.25"
          x2="18.25"
          y2="2.25"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="9.75"
          y1="6.25"
          x2="18.25"
          y2="6.25"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="1.75"
          y1="10.25"
          x2="18.25"
          y2="10.25"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="1.75"
          y1="14.25"
          x2="18.25"
          y2="14.25"
          stroke="black"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-string': {
    viewBox: '0 0 18 18',
    path: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 4V1H17V4"
          stroke="#181621"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6 17H12" stroke="#181621" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 1V17" stroke="#181621" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  'datafield-textarea': {
    viewBox: '0 0 18 10',
    path: (
      <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line
          x1="0.75"
          y1="1.25"
          x2="17.25"
          y2="1.25"
          stroke="#181621"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="0.75"
          y1="5.25"
          x2="17.25"
          y2="5.25"
          stroke="#181621"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="0.75"
          y1="9.25"
          x2="8.25"
          y2="9.25"
          stroke="#181621"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-boolean': {
    viewBox: '0 0 18 8',
    path: (
      <svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.75" y="0.75" width="16.5" height="6.5" rx="3.25" stroke="#181621" strokeWidth="1.5" />
        <circle cx="14" cy="4" r="3.25" stroke="#181621" strokeWidth="1.5" />
      </svg>
    ),
  },
  'datafield-user': {
    viewBox: '0 0 17 22',
    path: (
      <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="8.57894"
          cy="6.27803"
          r="4.77803"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.00002 17.7014C0.998732 17.3655 1.07385 17.0337 1.2197 16.7311C1.67736 15.8158 2.96798 15.3307 4.03892 15.111C4.81128 14.9462 5.59431 14.836 6.38217 14.7815C7.84084 14.6533 9.30793 14.6533 10.7666 14.7815C11.5544 14.8367 12.3374 14.9468 13.1099 15.111C14.1808 15.3307 15.4714 15.77 15.9291 16.7311C16.2224 17.3479 16.2224 18.064 15.9291 18.6808C15.4714 19.6419 14.1808 20.0812 13.1099 20.2918C12.3384 20.4634 11.5551 20.5766 10.7666 20.6304C9.57937 20.7311 8.38659 20.7494 7.19681 20.6854C6.92221 20.6854 6.65677 20.6854 6.38217 20.6304C5.59663 20.5773 4.81632 20.4641 4.04807 20.2918C2.96798 20.0812 1.68652 19.6419 1.2197 18.6808C1.0746 18.3747 0.999552 18.0401 1.00002 17.7014Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'datafield-children': {
    viewBox: '0 0 18 16',
    path: (
      <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="14" y="10" width="4" height="4" rx="1" transform="rotate(-90 14 10)" fill="black" />
        <rect x="14" y="16" width="4" height="4" rx="1" transform="rotate(-90 14 16)" fill="black" />
        <rect x="14" y="4" width="4" height="4" rx="1" transform="rotate(-90 14 4)" fill="black" />
        <rect x="0.5" y="9.5" width="3" height="3" rx="0.5" transform="rotate(-90 0.5 9.5)" stroke="black" />
        <path d="M14 8L4 8" stroke="black" />
        <path d="M14 2H10C9.44772 2 9 2.44772 9 3V13C9 13.5523 9.44772 14 10 14H14" stroke="black" />
      </svg>
    ),
  },
  examples: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.0491 2.92702C11.3491 2.00602 12.6521 2.00602 12.9511 2.92702L14.4701 7.60102C14.5355 7.80151 14.6625 7.9762 14.8332 8.10012C15.0038 8.22405 15.2092 8.29086 15.4201 8.29102H20.3351C21.3041 8.29102 21.7061 9.53102 20.9231 10.101L16.9471 12.989C16.7763 13.1132 16.6492 13.2882 16.584 13.4891C16.5188 13.6899 16.5188 13.9062 16.5841 14.107L18.1021 18.781C18.4021 19.703 17.3471 20.469 16.5641 19.899L12.5881 17.011C12.4172 16.8868 12.2114 16.8199 12.0001 16.8199C11.7888 16.8199 11.583 16.8868 11.4121 17.011L7.4361 19.899C6.6531 20.469 5.5981 19.702 5.8981 18.781L7.4161 14.107C7.48137 13.9062 7.48141 13.6899 7.4162 13.4891C7.351 13.2882 7.22389 13.1132 7.0531 12.989L3.0771 10.101C2.2931 9.53102 2.6971 8.29102 3.6651 8.29102H8.5791C8.79014 8.29107 8.9958 8.22436 9.16662 8.10042C9.33744 7.97648 9.46467 7.80167 9.5301 7.60102L11.0491 2.92702V2.92702Z"
          strokeWidth="2"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 23 23',
  },
  editor: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.21618 0H3.57089C1.59707 0 0 1.61093 0 3.59462V7.27156C0 9.25444 1.59741 10.8662 3.57089 10.8662H7.21618C9.18966 10.8662 10.7871 9.25444 10.7871 7.27156V3.59462C10.7871 1.61093 9.19 0 7.21618 0ZM3.57086 1.67439H7.21615C8.26196 1.67439 9.11262 2.53244 9.11262 3.59459V7.27153C9.11262 8.33298 8.26151 9.19173 7.21615 9.19173H3.57086C2.5255 9.19173 1.67439 8.33298 1.67439 7.27153V3.59459C1.67439 2.53244 2.52505 1.67439 3.57086 1.67439ZM20.4304 0H16.7839C14.8101 0 13.213 1.61093 13.213 3.59462V7.27156C13.213 9.25444 14.8104 10.8662 16.7839 10.8662H20.4304C22.4029 10.8662 24.0001 9.2542 24.0001 7.27156V3.59462C24.0001 1.61117 22.4033 0 20.4304 0ZM16.784 1.67439H20.4304C21.4752 1.67439 22.3258 2.53256 22.3258 3.59459V7.27153C22.3258 8.33286 21.4748 9.19173 20.4304 9.19173H16.784C15.7386 9.19173 14.8875 8.33298 14.8875 7.27153V3.59459C14.8875 2.53244 15.7382 1.67439 16.784 1.67439ZM3.57089 13.1338H7.21618C9.19023 13.1338 10.7871 14.745 10.7871 16.7296V20.4053C10.7871 22.389 9.19 24 7.21618 24H3.57089C1.59707 24 0 22.389 0 20.4053V16.7296C0 14.745 1.59684 13.1338 3.57089 13.1338ZM7.21615 14.8082H3.57086C2.52493 14.8082 1.67439 15.6663 1.67439 16.7295V20.4053C1.67439 21.4675 2.52505 22.3255 3.57086 22.3255H7.21615C8.26196 22.3255 9.11262 21.4675 9.11262 20.4053V16.7295C9.11262 15.6663 8.26208 14.8082 7.21615 14.8082ZM20.4303 13.1338H16.7839C14.8098 13.1338 13.213 14.745 13.213 16.7296V20.4053C13.213 22.389 14.81 24 16.7839 24H20.4303C22.4032 24 24 22.3888 24 20.4053V16.7296C24 14.7452 22.4034 13.1338 20.4303 13.1338ZM16.784 14.8082H20.4304C21.4753 14.8082 22.3257 15.6665 22.3257 16.7295V20.4053C22.3257 21.4673 21.4752 22.3255 20.4304 22.3255H16.784C15.7382 22.3255 14.8875 21.4675 14.8875 20.4053V16.7295C14.8875 15.6663 15.7381 14.8082 16.784 14.8082Z"
          fill="currentColor"
        />
      </svg>
    ),
    viewBox: '0 0 26 26',
  },
  logo: {
    path: (
      <svg width="3000" height="3163" viewBox="0 0 3000 3163" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="3000" height="3162.95" fill="none" />
        <path
          d="M1470.89 1448.81L2170 2488.19H820V706.392H2170L1470.89 1448.81ZM1408.21 1515.37L909.196 2045.3V2393.46H1998.84L1408.21 1515.37Z"
          fill="currentColor"
        />
      </svg>
    ),
    viewBox: '0 0 3000 3163',
  },
  integrations: {
    path: (
      <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.8763 5.74025C22.9405 5.78007 23 5.86544 23 6C23 6.13456 22.9405 6.21993 22.8763 6.25975L15.2643 10.9764C15.2286 10.9985 15.2065 11.0002 15.1941 11C15.178 10.9997 15.1533 10.9947 15.1237 10.9764C15.0666 10.941 15 10.8601 15 10.7166V1.28339C15 1.13995 15.0666 1.05902 15.1237 1.02364C15.1533 1.00533 15.178 1.00032 15.1941 1.00002C15.2065 0.999783 15.2286 1.00152 15.2643 1.02364L22.8763 5.74025Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path
          d="M1.12373 18.2597C1.05946 18.2199 1 18.1346 1 18C1 17.8654 1.05946 17.7801 1.12373 17.7403L8.73567 13.0236C8.77137 13.0015 8.79346 12.9998 8.80585 13C8.82198 13.0003 8.84672 13.0053 8.87627 13.0236C8.93338 13.059 9 13.1399 9 13.2834L9 22.7166C9 22.8601 8.93338 22.941 8.87627 22.9764C8.84672 22.9947 8.82198 22.9997 8.80585 23C8.79346 23.0002 8.77137 22.9985 8.73567 22.9764L1.12373 18.2597Z"
          stroke="currentColor"
          strokeWidth="2"
        />
        <rect y="5" width="16" height="2" rx="1" fill="currentColor" />
        <rect x="9" y="17" width="15" height="2" rx="1" fill="currentColor" />
      </svg>
    ),
    viewBox: '0 0 24 24',
  },
  lightning: {
    path: (
      <svg width="8" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.483624 11.9172C0.282456 11.7842 0.204801 11.5267 0.298969 11.3047L2.33733 6.50005H0.5C0.328771 6.50005 0.169449 6.41242 0.0777478 6.26782C-0.0139532 6.12322 -0.02528 5.94174 0.047729 5.78686L2.64032 0.28681C2.72285 0.111722 2.89902 0 3.09259 0H6.54852C6.72002 0 6.87955 0.0878963 6.97117 0.232867C7.0628 0.377838 7.07373 0.559654 7.00014 0.714561L5.43924 4.00006H7.49999C7.7005 4.00006 7.88162 4.11985 7.9601 4.30437C8.03858 4.48889 7.99923 4.70245 7.86015 4.84688L1.11942 11.8468C0.952168 12.0205 0.684794 12.0501 0.483624 11.9172ZM6.32437 5.00006H4.64814C4.47664 5.00006 4.31711 4.91217 4.22548 4.7672C4.13386 4.62222 4.12292 4.44041 4.19652 4.2855L5.75742 0.999999H3.40966L1.28845 5.50005H3.09259C3.26034 5.50005 3.4169 5.58417 3.5095 5.72404C3.6021 5.86391 3.61839 6.0409 3.55288 6.19532L2.27675 9.20332L6.32437 5.00006Z"
          fill="#F5F5F6"
        />
      </svg>
    ),
    viewBox: '0 0 8 12',
  },

  insert: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 8.59277V17.3844"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4 12.9886H8.59998"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6229 1H7.37714C3.45714 1 1 3.7745 1 7.70219V18.2978C1 22.2255 3.44571 25 7.37714 25H18.6229C22.5543 25 25 22.2255 25 18.2978V7.70219C25 3.7745 22.5543 1 18.6229 1Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 26 26',
  },
  theme: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.33333 25C4.91885 25 3.56229 24.4381 2.5621 23.4379C1.5619 22.4377 1 21.0812 1 19.6667V3.66667C1 2.95942 1.28095 2.28115 1.78105 1.78105C2.28115 1.28095 2.95942 1 3.66667 1H9C9.70724 1 10.3855 1.28095 10.8856 1.78105C11.3857 2.28115 11.6667 2.95942 11.6667 3.66667V19.6667C11.6667 21.0812 11.1048 22.4377 10.1046 23.4379M6.33333 25C7.74782 25 9.10438 24.4381 10.1046 23.4379M6.33333 25H22.3333C23.0406 25 23.7189 24.719 24.219 24.219C24.719 23.7189 25 23.0406 25 22.3333V17C25 16.2928 24.719 15.6145 24.219 15.1144C23.7189 14.6143 23.0406 14.3333 22.3333 14.3333H19.2093M10.1046 23.4379L15.7616 17.781L21.4187 12.124C21.9186 11.6239 22.1994 10.9458 22.1994 10.2387C22.1994 9.53156 21.9186 8.85341 21.4187 8.35333L17.6467 4.58133C17.1466 4.08141 16.4684 3.80057 15.7613 3.80057C15.0542 3.80057 14.3761 4.08141 13.876 4.58133L11.6667 6.79067"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 26 26',
  },
  gear: {
    path: (
      <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.8851 7.67429L22.1079 6.32571C21.4505 5.18462 19.9934 4.79097 18.8508 5.44571V5.44571C18.3069 5.76613 17.6578 5.85704 17.0468 5.69839C16.4358 5.53974 15.913 5.14456 15.5936 4.6C15.3882 4.25387 15.2778 3.85963 15.2736 3.45714V3.45714C15.2922 2.81186 15.0487 2.18655 14.5988 1.72366C14.1488 1.26078 13.5306 0.999734 12.8851 1H11.3194C10.6869 0.999993 10.0805 1.25201 9.63441 1.70028C9.18828 2.14856 8.93918 2.75614 8.94222 3.38857V3.38857C8.92347 4.69433 7.85955 5.74299 6.55365 5.74286C6.15117 5.73868 5.75692 5.62829 5.41079 5.42286V5.42286C4.26813 4.76811 2.81111 5.16176 2.15365 6.30286L1.31936 7.67429C0.662693 8.81396 1.05099 10.2701 2.18793 10.9314V10.9314C2.92697 11.3581 3.38223 12.1466 3.38223 13C3.38223 13.8534 2.92697 14.6419 2.18793 15.0686V15.0686C1.05243 15.7255 0.663713 17.1781 1.31936 18.3143V18.3143L2.10793 19.6743C2.41598 20.2301 2.93284 20.6403 3.54412 20.814C4.15541 20.9878 4.81073 20.9107 5.36508 20.6V20.6C5.91003 20.282 6.55942 20.1949 7.16891 20.358C7.7784 20.5211 8.29749 20.9209 8.61079 21.4686C8.81622 21.8147 8.92661 22.2089 8.93079 22.6114V22.6114C8.93079 23.9306 10.0002 25 11.3194 25H12.8851C14.1998 25 15.2674 23.9376 15.2736 22.6229V22.6229C15.2706 21.9884 15.5213 21.3791 15.9699 20.9305C16.4185 20.4819 17.0278 20.2312 17.6622 20.2343C18.0637 20.245 18.4564 20.355 18.8051 20.5543V20.5543C19.9447 21.211 21.4008 20.8227 22.0622 19.6857V19.6857L22.8851 18.3143C23.2036 17.7676 23.291 17.1165 23.128 16.5051C22.9649 15.8938 22.5649 15.3727 22.0165 15.0571V15.0571C21.4681 14.7416 21.0681 14.2205 20.905 13.6092C20.742 12.9978 20.8294 12.3467 21.1479 11.8C21.3551 11.4384 21.6549 11.1386 22.0165 10.9314V10.9314C23.1466 10.2704 23.534 8.82282 22.8851 7.68571V7.68571V7.67429Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.108 16.2915C13.9258 16.2915 15.3994 14.8179 15.3994 13C15.3994 11.1822 13.9258 9.70862 12.108 9.70862C10.2901 9.70862 8.81653 11.1822 8.81653 13C8.81653 14.8179 10.2901 16.2915 12.108 16.2915Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 25 26',
  },
  success: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9 12L11 14L15 10M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 26 26',
  },
  'menu-vertical': {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.2929 5.70711C11.4804 5.89464 11.7348 6 12 6C12.2652 6 12.5196 5.89464 12.7071 5.70711C12.8946 5.51957 13 5.26522 13 5C13 4.73478 12.8946 4.48043 12.7071 4.29289C12.5196 4.10536 12.2652 4 12 4C11.7348 4 11.4804 4.10536 11.2929 4.29289C11.1054 4.48043 11 4.73478 11 5C11 5.26522 11.1054 5.51957 11.2929 5.70711Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <path
          d="M11.2929 19.7071C11.4804 19.8946 11.7348 20 12 20C12.2652 20 12.5196 19.8946 12.7071 19.7071C12.8946 19.5196 13 19.2652 13 19C13 18.7348 12.8946 18.4804 12.7071 18.2929C12.5196 18.1054 12.2652 18 12 18C11.7348 18 11.4804 18.1054 11.2929 18.2929C11.1054 18.4804 11 18.7348 11 19C11 19.2652 11.1054 19.5196 11.2929 19.7071Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 26 26',
  },
  'node-tree': {
    viewBox: '0 0 24 24',
    path: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17.25 6.75366H21.75C22.1478 6.75366 22.5294 6.59563 22.8107 6.31432C23.092 6.03302 23.25 5.65149 23.25 5.25366V2.25366C23.25 1.85584 23.092 1.47431 22.8107 1.193C22.5294 0.911697 22.1478 0.753662 21.75 0.753662H17.25C16.8522 0.753662 16.4706 0.911697 16.1893 1.193C15.908 1.47431 15.75 1.85584 15.75 2.25366V3.00366H8.25V2.25366C8.25 1.85584 8.09196 1.47431 7.81066 1.193C7.52936 0.911697 7.14782 0.753662 6.75 0.753662H2.25C1.85218 0.753662 1.47064 0.911697 1.18934 1.193C0.908035 1.47431 0.75 1.85584 0.75 2.25366V5.25366C0.75 5.65149 0.908035 6.03302 1.18934 6.31432C1.47064 6.59563 1.85218 6.75366 2.25 6.75366H6.75C7.14782 6.75366 7.52936 6.59563 7.81066 6.31432C8.09196 6.03302 8.25 5.65149 8.25 5.25366V4.50366H11.25V19.5037C11.2504 19.9014 11.4086 20.2827 11.6898 20.5639C11.971 20.8451 12.3523 21.0033 12.75 21.0037H15.75V21.7537C15.75 22.1515 15.908 22.533 16.1893 22.8143C16.4706 23.0956 16.8522 23.2537 17.25 23.2537H21.75C22.1478 23.2537 22.5294 23.0956 22.8107 22.8143C23.092 22.533 23.25 22.1515 23.25 21.7537V18.7537C23.25 18.3558 23.092 17.9743 22.8107 17.693C22.5294 17.4117 22.1478 17.2537 21.75 17.2537H17.25C16.8522 17.2537 16.4706 17.4117 16.1893 17.693C15.908 17.9743 15.75 18.3558 15.75 18.7537V19.5037H12.75V12.7537H15.75V13.5037C15.75 13.9015 15.908 14.283 16.1893 14.5643C16.4706 14.8456 16.8522 15.0037 17.25 15.0037H21.75C22.1478 15.0037 22.5294 14.8456 22.8107 14.5643C23.092 14.283 23.25 13.9015 23.25 13.5037V10.5037C23.25 10.1058 23.092 9.72431 22.8107 9.443C22.5294 9.1617 22.1478 9.00366 21.75 9.00366H17.25C16.8522 9.00366 16.4706 9.1617 16.1893 9.443C15.908 9.72431 15.75 10.1058 15.75 10.5037V11.2537H12.75V4.50366H15.75V5.25366C15.75 5.65149 15.908 6.03302 16.1893 6.31432C16.4706 6.59563 16.8522 6.75366 17.25 6.75366ZM17.25 2.25366H21.75V5.25366H17.25V2.25366ZM6.75 5.25366H2.25V2.25366H6.75V5.25366ZM17.25 18.7537H21.75V21.7537H17.25V18.7537ZM17.25 10.5037H21.75V13.5037H17.25V10.5037Z"
          fill="#852FFF"
        />
      </svg>
    ),
  },
  play: {
    viewBox: '0 0 10 12',
    path: (
      <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.40298 4.89021C10.199 5.38345 10.199 6.61655 9.40298 7.10979L1.79104 11.8264C0.995025 12.3196 0 11.7031 0 10.7166L0 1.28339C0 0.296908 0.995025 -0.319643 1.79104 0.173597L9.40298 4.89021Z"
          fill="white"
        />
      </svg>
    ),
  },
  'play-video': {
    path: (
      <svg width="34" height="35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.84 14.8262C23.8 15.3804 23.8 16.7661 22.84 17.3203L9.16 25.2185C8.2 25.7727 7 25.0799 7 23.9714L7 8.17509C7 7.06658 8.2 6.37376 9.16 6.92801L22.84 14.8262Z"
          fill="white"
          fillOpacity="0.3"
        />
        <path
          d="M27.84 14.8262C28.8 15.3804 28.8 16.7661 27.84 17.3203L14.16 25.2185C13.2 25.7727 12 25.0799 12 23.9714L12 8.17509C12 7.06658 13.2 6.37376 14.16 6.92801L27.84 14.8262Z"
          fill="white"
        />
      </svg>
    ),
    viewBox: '0 0 34 35',
  },

  watch: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.25 9C11.25 9.59674 11.0129 10.169 10.591 10.591C10.169 11.0129 9.59674 11.25 9 11.25C8.40326 11.25 7.83097 11.0129 7.40901 10.591C6.98705 10.169 6.75 9.59674 6.75 9C6.75 8.40326 6.98705 7.83097 7.40901 7.40901C7.83097 6.98705 8.40326 6.75 9 6.75C9.59674 6.75 10.169 6.98705 10.591 7.40901C11.0129 7.83097 11.25 8.40326 11.25 9V9Z"
          strokeWidth="2"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.84375 9C2.79925 5.95725 5.6425 3.75 9.00025 3.75C12.3587 3.75 15.2012 5.95725 16.1567 9C15.2012 12.0428 12.3587 14.25 9.00025 14.25C5.6425 14.25 2.79925 12.0428 1.84375 9Z"
          strokeWidth="2"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 18 18',
  },
  download: {
    path: (
      <svg width="26" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 12V12.75C3 13.3467 3.23705 13.919 3.65901 14.341C4.08097 14.7629 4.65326 15 5.25 15H12.75C13.3467 15 13.919 14.7629 14.341 14.341C14.7629 13.919 15 13.3467 15 12.75V12M12 9L9 12M9 12L6 9M9 12V3"
          strokeWidth="2"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    viewBox: '0 0 18 18',
  },
  'spacing-x': {
    path: (
      <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="19.9"
          y="3.8998"
          width="16.2"
          height="16.2"
          rx="1.8"
          transform="rotate(90 19.9 3.8998)"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6927 19.2001H17.846V19.2H7.04636L5.54636 19.2L3 19.2C3.37065 20.2487 4.37077 21 5.54636 21H18.1464C19.3219 21 20.322 20.2487 20.6927 19.2001ZM20.6928 4.8001H18.1598C18.1553 4.80003 18.1508 4.8 18.1464 4.8H7.04636L5.54636 4.8C5.54595 4.8 5.54554 4.8 5.54513 4.8H3C3.37065 3.75133 4.37077 3 5.54636 3H18.1464C19.322 3 20.3221 3.75137 20.6928 4.8001Z"
          fill="#DBD9DE"
        />
      </svg>
    ),
    viewBox: '0 0 24 24',
  },
  'spacing-y': {
    path: (
      <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="3.8998"
          y="4.1"
          width="16.2"
          height="16.2"
          rx="1.8"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.2001 3.30731L19.2001 6.15398L19.2 6.15398L19.2 16.9536L19.2 18.4536L19.2 21C20.2487 20.6293 21 19.6292 21 18.4536L21 5.85364C21 4.67808 20.2487 3.67799 19.2001 3.30731ZM4.8001 3.30724L4.8001 5.84021C4.80003 5.84468 4.8 5.84915 4.8 5.85364L4.8 16.9536L4.8 18.4536C4.8 18.454 4.8 18.4545 4.8 18.4549L4.8 21C3.75133 20.6293 3 19.6292 3 18.4536L3 5.85364C3 4.678 3.75137 3.67786 4.8001 3.30724Z"
          fill="#DBD9DE"
        />
      </svg>
    ),
    viewBox: '0 0 24 24',
  },
  home: {
    viewBox: '0 0 25 26',
    path: (
      <svg viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.98866 23.5257V19.8456C8.98864 18.9096 9.75174 18.149 10.6972 18.1427H14.1605C15.1105 18.1427 15.8806 18.9051 15.8806 19.8456V19.8456V23.5371C15.8804 24.3318 16.5211 24.9814 17.3236 25H19.6325C21.9341 25 23.8 23.1528 23.8 20.8742V20.8742V10.4054C23.7877 9.50899 23.3626 8.66722 22.6456 8.11964L14.7493 1.82236C13.3659 0.72588 11.3994 0.72588 10.0161 1.82236L2.15443 8.13107C1.43471 8.67643 1.00886 9.5196 1 10.4168V20.8742C1 23.1528 2.86585 25 5.16749 25H7.47635C8.29883 25 8.96557 24.3399 8.96557 23.5257V23.5257"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  desktop: {
    viewBox: '0 0 19 17',
    path: (
      <svg viewBox="0 0 19 17" xmlns="http://www.w3.org/2000/svg" fill="transparent">
        <path
          d="M5.15385 16.4286H13.4615M1 2.18681L1 11.6813C1 12.3368 1.53135 12.8681 2.18681 12.8681L16.4286 12.8681C17.084 12.8681 17.6154 12.3368 17.6154 11.6813V2.18681C17.6154 1.53136 17.084 1 16.4286 1L2.18681 1C1.53135 1 1 1.53135 1 2.18681Z"
          stroke="currentColor"
        />
      </svg>
    ),
  },
  notebook: {
    viewBox: '0 0 20 18',
    path: (
      <svg viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg" fill="transparent">
        <path
          d="M0 17H20M2 2.33333L2 13C2 13.7364 2.59695 14.3333 3.33333 14.3333H16.6667C17.403 14.3333 18 13.7364 18 13V2.33333C18 1.59695 17.403 1 16.6667 1L3.33333 1C2.59695 1 2 1.59695 2 2.33333Z"
          stroke="currentColor"
        />
      </svg>
    ),
  },
  tablet: {
    viewBox: '0 0 16 18',
    path: (
      <svg viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg" fill="transparent">
        <path
          d="M6.14286 13.5714H9.57143M2.14286 17H13.5714C14.2026 17 14.7143 16.4883 14.7143 15.8571V2.14286C14.7143 1.51167 14.2026 1 13.5714 1H2.14286C1.51167 1 1 1.51168 1 2.14286V15.8571C1 16.4883 1.51167 17 2.14286 17Z"
          stroke="currentColor"
        />
      </svg>
    ),
  },
  mobile: {
    viewBox: '0 0 13 18',
    path: (
      <svg viewBox="0 0 13 18" xmlns="http://www.w3.org/2000/svg" fill="transparent">
        <path
          d="M5 13.5714H8.42857M2.14286 17H11.2857C11.9169 17 12.4286 16.4883 12.4286 15.8571V2.14286C12.4286 1.51167 11.9169 1 11.2857 1H2.14286C1.51167 1 1 1.51168 1 2.14286V15.8571C1 16.4883 1.51167 17 2.14286 17Z"
          stroke="currentColor"
        />
      </svg>
    ),
  },
  'solid-chevron-down': {
    viewBox: '0 0 24 24',
    path: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.6928 14.8C12.3849 15.3333 11.6151 15.3333 11.3072 14.8L9.22872 11.2C8.9208 10.6667 9.3057 10 9.92154 10L14.0785 10C14.6943 10 15.0792 10.6667 14.7713 11.2L12.6928 14.8Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  'solid-chevron-up': {
    viewBox: '0 0 24 24',
    path: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.6928 9.2C12.3849 8.66667 11.6151 8.66667 11.3072 9.2L9.22872 12.8C8.9208 13.3333 9.3057 14 9.92154 14L14.0785 14C14.6943 14 15.0792 13.3333 14.7713 12.8L12.6928 9.2Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  add: {
    viewBox: '0 0 13 13',
    path: (
      <svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.38086 2.82544V9.93655"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.82422 6.38086H9.93533"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  delete: {
    viewBox: '0 0 16 16',
    path: (
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 4H3.33333H14"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33398 3.99992V2.66659C5.33398 2.31296 5.47446 1.97382 5.72451 1.72378C5.97456 1.47373 6.3137 1.33325 6.66732 1.33325H9.33398C9.68761 1.33325 10.0267 1.47373 10.2768 1.72378C10.5268 1.97382 10.6673 2.31296 10.6673 2.66659V3.99992M12.6673 3.99992V13.3333C12.6673 13.6869 12.5268 14.026 12.2768 14.2761C12.0267 14.5261 11.6876 14.6666 11.334 14.6666H4.66732C4.3137 14.6666 3.97456 14.5261 3.72451 14.2761C3.47446 14.026 3.33398 13.6869 3.33398 13.3333V3.99992H12.6673Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  duplicate: {
    viewBox: '0 0 16 16',
    path: (
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.33268 4.66667V10C5.33268 10.3536 5.47316 10.6928 5.72321 10.9428C5.97326 11.1929 6.31239 11.3333 6.66602 11.3333H10.666M5.33268 4.66667V3.33333C5.33268 2.97971 5.47316 2.64057 5.72321 2.39052C5.97326 2.14048 6.31239 2 6.66602 2H9.72335C9.90015 2.00004 10.0697 2.0703 10.1947 2.19533L13.1373 5.138C13.2624 5.263 13.3326 5.43254 13.3327 5.60933V10C13.3327 10.3536 13.1922 10.6928 12.9422 10.9428C12.6921 11.1929 12.353 11.3333 11.9993 11.3333H10.666M5.33268 4.66667H3.99935C3.64573 4.66667 3.30659 4.80714 3.05654 5.05719C2.80649 5.30724 2.66602 5.64638 2.66602 6V12.6667C2.66602 13.0203 2.80649 13.3594 3.05654 13.6095C3.30659 13.8595 3.64573 14 3.99935 14H9.33268C9.6863 14 10.0254 13.8595 10.2755 13.6095C10.5255 13.3594 10.666 13.0203 10.666 12.6667V11.3333"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  'rectangle-outline': {
    viewBox: '0 0 11 8',
    path: (
      <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="9.66667" height="7" rx="1.5" stroke="currentColor" />
      </svg>
    ),
  },
  'data-link': {
    viewBox: '0 0 24 24',
    path: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.48569 9.35412L4.69897 11.706C3.76065 12.2888 3.47244 13.5219 4.05523 14.4602L5.83868 17.3317C6.42146 18.27 7.65456 18.5582 8.59287 17.9754L12.3796 15.6235L11.5882 14.3493L7.80145 16.7012C7.56687 16.8469 7.2586 16.7748 7.1129 16.5403L5.32945 13.6688C5.18376 13.4342 5.25581 13.126 5.49039 12.9803L9.27711 10.6283L8.48569 9.35412ZM14.7229 12.4023L18.5096 10.0504C18.7442 9.90468 18.8162 9.5964 18.6705 9.36183L16.8871 6.49038C16.7414 6.25581 16.4331 6.18375 16.1985 6.32945L12.4118 8.6814L11.6204 7.40717L15.4071 5.05522C16.3454 4.47244 17.5785 4.76065 18.1613 5.69896L19.9448 8.5704C20.5276 9.50872 20.2393 10.7418 19.301 11.3246L15.5143 13.6765L14.7229 12.4023Z"
          fill="currentColor"
        />
        <path
          d="M9.45746 13.0945L14.5101 9.95632"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
  },
  boolean: {
    viewBox: '0 0 24 24',
    path: (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3.75" y="3.75" width="16.5" height="6.5" rx="3.25" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="17" cy="7" r="0.75" fill="currentColor" stroke="currentColor" strokeWidth="0.5" />
        <rect
          x="3.75"
          y="13.75"
          width="16.5"
          height="6.5"
          rx="3.25"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <circle cx="7" cy="17" r="0.75" fill="currentColor" stroke="currentColor" strokeWidth="0.5" />
      </svg>
    ),
  },
  'add-user': {
    viewBox: '0 0 20 20',
    path: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.87737 13.2062C4.03337 13.2062 0.750366 13.7872 0.750366 16.1152C0.750366 18.4422 4.01237 19.0452 7.87737 19.0452C11.7214 19.0452 15.0044 18.4632 15.0044 16.1362C15.0044 13.8092 11.7424 13.2062 7.87737 13.2062Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.87733 9.88588C10.4133 9.88588 12.4453 7.85288 12.4453 5.31788C12.4453 2.78188 10.4133 0.749878 7.87733 0.749878C5.34233 0.749878 3.30933 2.78188 3.30933 5.31788C3.30933 7.85288 5.34233 9.88588 7.87733 9.88588Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2041 6.66907V10.6791"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.2499 8.67395H15.1599"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  lock: {
    viewBox: '0 0 18 20',
    path: (
      <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.4235 7.4478V5.3008C13.4235 2.7878 11.3855 0.7498 8.87249 0.7498C6.35949 0.7388 4.31349 2.7668 4.30249 5.2808V5.3008V7.4478"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.6832 19.2496H5.04224C2.94824 19.2496 1.25024 17.5526 1.25024 15.4576V11.1686C1.25024 9.07359 2.94824 7.37659 5.04224 7.37659H12.6832C14.7772 7.37659 16.4752 9.07359 16.4752 11.1686V15.4576C16.4752 17.5526 14.7772 19.2496 12.6832 19.2496Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.86292 12.2027V14.4237"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  share: {
    viewBox: '0 0 20 20',
    path: (
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.8554 6.12111L8.1916 11.8227L1.56064 7.74147C0.691759 7.20657 0.867871 5.88697 1.8467 5.60287L17.5022 1.04743C18.3925 0.789782 19.2156 1.62446 18.949 2.51889L14.304 18.1582C14.013 19.1369 12.7082 19.3064 12.1809 18.4325L8.1916 11.8227"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },

  help: {
    viewBox: '0 0 18 18',
    path: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.3992 3.87487L16.471 3.80311C16.8169 3.45728 16.8169 2.89668 16.471 2.55085L15.4505 1.53054C15.1046 1.18475 14.5439 1.18475 14.198 1.53054L14.1269 1.60183C12.6235 0.554479 10.834 -0.00478236 9.00161 3.34124e-05H9.00007C7.16719 -0.00497973 5.37722 0.554242 3.87326 1.60167L3.80219 1.53062C3.4561 1.18538 2.89578 1.18538 2.54969 1.53062L1.52913 2.55085C1.18328 2.89668 1.18328 3.45728 1.52913 3.80311L1.60083 3.87476C-0.53361 6.95835 -0.53361 11.0415 1.60083 14.1251L1.52901 14.1969C1.18316 14.5427 1.18316 15.1034 1.52901 15.4491L2.54953 16.4695C2.89562 16.8147 3.45594 16.8147 3.80203 16.4695L3.8731 16.3984C5.37588 17.4454 7.1645 18.0045 8.99612 18H9.00007C10.8329 18.0049 12.6228 17.4458 14.1268 16.3984L14.1979 16.4695C14.5438 16.8152 15.1046 16.8152 15.4504 16.4695L16.4709 15.4491C16.8168 15.1034 16.8168 14.5427 16.4709 14.1969L16.3991 14.1251C18.5336 11.0416 18.5336 6.95839 16.3991 3.87487H16.3992ZM13.4999 11.2666C13.1522 11.0603 12.7089 11.1161 12.4232 11.4022L11.4027 12.4224C11.1165 12.7079 11.0608 13.1512 11.2672 13.4988C9.84071 14.2152 8.15943 14.2152 6.73293 13.4988C6.93938 13.1512 6.88359 12.7079 6.59743 12.4224L5.57704 11.4022C5.29139 11.1161 4.84797 11.0603 4.50034 11.2667C3.78379 9.84047 3.78379 8.15957 4.50034 6.73335C4.84797 6.93972 5.29135 6.8839 5.57696 6.59784L6.59743 5.57764C6.88359 5.29209 6.93938 4.84877 6.73293 4.50124C8.15943 3.78491 9.84067 3.78491 11.2672 4.50124C11.0608 4.8488 11.1166 5.29205 11.4027 5.5776L12.4231 6.59784C12.7087 6.8839 13.1521 6.93972 13.4998 6.73335C14.2163 8.15953 14.2163 9.84043 13.4999 11.2666ZM9.00007 0.473716H9.00157C10.7081 0.469255 12.376 0.981306 13.7859 1.94257L11.5924 4.13564C9.97143 3.27472 8.02863 3.27472 6.40764 4.13564L4.21422 1.94257C5.62461 0.981148 7.29305 0.469097 9.00007 0.473716ZM0.473796 9.00667C0.467676 7.2981 0.979512 5.62778 1.94179 4.21581L4.13478 6.40836C3.27358 8.02899 3.27358 9.97137 4.13478 11.592L1.94175 13.7844C0.982 12.3761 0.470322 10.7107 0.473796 9.00667ZM9.00007 17.5263H8.9964C7.29053 17.5305 5.62335 17.0185 4.21402 16.0576L6.40757 13.8644C8.02855 14.7256 9.97143 14.7256 11.5924 13.8644L13.7858 16.0574C12.3754 17.0187 10.707 17.5308 9.00007 17.5263ZM13.8654 11.5919C14.7265 9.97121 14.7265 8.02879 13.8654 6.40813L16.0584 4.21561C18.0156 7.10507 18.0156 10.8949 16.0584 13.7844L13.8654 11.5919Z"
          fill="currentColor"
        />
      </svg>
    ),
  },
  organization: {
    viewBox: '0 0 22 16',
    path: (
      <svg viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.9488 10.54C7.49884 10.54 4.58789 11.1038 4.58789 13.2795C4.58789 15.4562 7.51765 16.0001 10.9488 16.0001C14.3988 16.0001 17.3098 15.4364 17.3098 13.2606C17.3098 11.084 14.38 10.54 10.9488 10.54"
          fill="#501C99"
        />
        <path
          opacity="0.4"
          d="M10.949 8.46703C13.2851 8.46703 15.1583 6.58307 15.1583 4.23351C15.1583 1.88306 13.2851 0 10.949 0C8.61293 0 6.73975 1.88306 6.73975 4.23351C6.73975 6.58307 8.61293 8.46703 10.949 8.46703"
          fill="#AA6DFF"
        />
        <path
          opacity="0.4"
          d="M20.0881 5.21923C20.6925 2.84176 18.9205 0.706543 16.664 0.706543C16.4187 0.706543 16.1841 0.73356 15.9549 0.779488C15.9244 0.786692 15.8904 0.802002 15.8725 0.829019C15.8519 0.86324 15.8671 0.909168 15.8895 0.938886C16.5673 1.89528 16.9568 3.0597 16.9568 4.30967C16.9568 5.50741 16.5996 6.6241 15.9728 7.55077C15.9083 7.64623 15.9656 7.77501 16.0793 7.79482C16.2369 7.82274 16.3981 7.83715 16.5629 7.84165C18.2059 7.88488 19.6807 6.82132 20.0881 5.21923"
          fill="#AA6DFF"
        />
        <path
          d="M21.8094 10.817C21.5086 10.1722 20.7824 9.72999 19.6783 9.51295C19.1572 9.38507 17.747 9.20496 16.4352 9.22928C16.4155 9.23198 16.4048 9.24549 16.403 9.25449C16.4003 9.2671 16.4057 9.28871 16.4316 9.30222C17.0378 9.60391 19.3811 10.916 19.0865 13.6834C19.074 13.8032 19.1698 13.9068 19.2888 13.8888C19.8655 13.8059 21.3492 13.4853 21.8094 12.4866C22.0637 11.9589 22.0637 11.3456 21.8094 10.817"
          fill="#501C99"
        />
        <path
          opacity="0.4"
          d="M6.04459 0.779976C5.81626 0.733147 5.58077 0.707031 5.33543 0.707031C3.07901 0.707031 1.30701 2.84225 1.9123 5.21972C2.31882 6.82181 3.79355 7.88536 5.43661 7.84214C5.60136 7.83763 5.76343 7.82232 5.92013 7.79531C6.03384 7.7755 6.09115 7.64672 6.02668 7.55126C5.3999 6.62368 5.04263 5.5079 5.04263 4.31016C5.04263 3.05928 5.43303 1.89486 6.11085 0.939375C6.13234 0.909656 6.14845 0.863728 6.12696 0.829507C6.10906 0.80159 6.07593 0.787181 6.04459 0.779976"
          fill="#AA6DFF"
        />
        <path
          d="M2.32156 9.5127C1.21752 9.72973 0.492248 10.1719 0.191392 10.8167C-0.0637974 11.3453 -0.0637974 11.9586 0.191392 12.4872C0.651629 13.4851 2.13531 13.8066 2.71195 13.8885C2.83104 13.9065 2.92595 13.8038 2.91342 13.6832C2.61883 10.9167 4.9621 9.60456 5.56918 9.30287C5.59425 9.28846 5.59962 9.26775 5.59694 9.25424C5.59515 9.24523 5.5853 9.23173 5.5656 9.22992C4.25294 9.20471 2.84358 9.38482 2.32156 9.5127"
          fill="#501C99"
        />
      </svg>
    ),
  },
};
